// 中文
const CHINESE = {
  solved: '已解决',
  unsolved: '未解决',
  helpful: '有用',
  'not helpful': '无用',
  'tip question1': '您好',
  'tip question2': '您是否有以下问题?',
  'new feedback': '新问题',
  more: '更多',
  feedback: '反馈',
  'feedback tip': '填写详细信息能帮助我们更快解决问题',
  'question type': '问题类型',
  'email address': '邮件地址',
  description: '描述',
  images: '添加图片',
  submit: '提交',
  'feedback history': '反馈列表',
  'feedback id': '单号',
  'rate our service': '为本次服务评分',
  // 马甲站 History 已评标签（V1）；其余语种回落 en
  Rated: '已评价',
  'Reasons for dissatisfaction': '不满意的原因',
  'Please input your feedback': '请输入您的反馈',
  processing: '处理中',
  'wait for your reply': '等待您的回复',
  'leave some comments on our service': '是否满意我们的服务',
  collapse: '收起',
  'service detail': '反馈详情',
  notification: '提示',
  'submit modal tip': '感谢您的反馈，我们尽快回复您',
  confirm: '确认',
  'satisfaction modal tip': '您的鼓励将驱使我们的进步',
  'thank rate': '感谢您的评分，您的评分将使我们提供更好的服务',
  'tip close': '一旦问题关闭后您将无法收到该反馈的回复',
  back: '返回',
  send: '发送',
  'select faq type': '选择一个问题类型',
  'network error': '网络错误',

  hello: '你好,',
  'What can we do to help': '我们能做些什么来帮助你？',
  Search: '搜索',
  'Contact Us': '联系我们',
  'Nothing more to load': '没有更多的东西需要加载',
  'Search Result': '搜索问题',
  'Found {value} results': '找到{value}个结果',
  'No results for': '找不到以下项的结果',
  'Related results': '相似的问题',
  'Still need help': '还需要帮助吗？',
  'Thanks for your feedback': '谢谢你的反馈意见!',
  'FAQ Content': 'FAQ 内容',
  'Was this article helpful': '这篇文章有帮助吗？',
  No: '否',
  Yes: '是',
  '{min} out of {total} found this helpful':
    '{total}人中，有{min}人觉得这很有帮组。',
  'No data': '没有数据',
  'Please fill out the form with as many details as possible':
    '请尽可能填写下列信息表单。',
  'feedback type': '反馈类型',
  'Select your feedback type': '选择你的反馈类型',
  'Select your {value}': '选择你的{value}',
  'Cannot be blank': '不能是空白',
  'Character limit exceeded': '超过了字符限制',
  'Please enter a valid email': '请输入一个有效的电子邮件',
  success: '成功',
  fail: '失败',
  complete: '已完成',
  error: '错误',
  close: '关闭',
  leave: '离开',
  stay: '留下',
  cancel: '取消',
  'You will not be able to receive a reply after it is closed':
    '关闭后，你将无法收到回复。',
  'Image uploading failed': '图片上传失败',
  'Image reviewing failed': '图片上传失败，请确保图片与问题相关且不含不当内容',
  'You can only upload a maximum of {limit} images':
    '你最多只能上传{limit}张图片',
  'Please check if the image format is .JPG or .PNG':
    '请检查图像格式是否为.JPG或.PNG。',
  'File uploading failed': '文件上传失败',
  'File reviewing failed': '文件上传失败，请确保文件与问题相关且不含不当内容',
  'You can only upload a maximum of {limit} files':
    '你最多只能上传{limit}个文件',
  'Please check the file format': '请检查文件格式',
  Note: '通知',
  'Do you want to submit the current feedback': '你想提交当前的反馈吗？',
  'A customer service representative will reply within {hour} hours':
    '客户将在{hour}小时内作出答复。',
  'This feedback will be closed. Please make a comprehensive evaluation':
    '这个反馈将关闭，你可以进一步的评价。',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    '您的反馈已因超过时间限制而结束。如果您有任何问题，请创建新的反馈。谢谢你',
  'Do you want to close the current feedback': '你想关闭当前的反馈吗？',
  'Rate Service': '评价服务',
  'Are you satisfied with our service': '您对我们的服务满意吗？',
  'Thank you for your feedback! We will continue to improve our service':
    '感谢你的反馈！我们将继续改进我们的服务',
  'You already rated this customer service less than {hour} hours ago':
    '您在不到{hour}前已经对该客户服务进行了评价。',
  'Thank you for your feedback! We will continue to help you solve the problem':
    '谢谢你的反馈！我们将继续帮助你解决问题。',
  'Return to top': '返回顶部',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `系统错误 (T_T)
请通过 {AppName} App → 帮助中心，重新打开反馈页面。`,
  'System error. Sign expired.': '系统错误, 签名过期。',
  'Network Status': '网络测速',
  Testing: '测速中',
  'Please allow us to access your network status information to help solve the issue.':
    '请允许我们采集您的网络状态信息，以更快更好地解决问题。',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    '网络测速中，预计需要10~30秒钟，请等待...',
  'Done! Thank you!': '已采集完成，感谢',
  OK: '同意'
}

// 繁体
const ChineseTrad = {
  solved: '已解決',
  unsolved: '未解決',
  helpful: '有用',
  'not helpful': '無用',
  'tip question1': '您好',
  'tip question2': '您是否有以下問題?',
  'new feedback': '新問題',
  more: '更多',
  feedback: '回饋',
  'feedback tip': '填寫詳細資訊能幫助我們更快解決問題',
  'question type': '問題類型',
  'email address': '郵件地址',
  description: '描述',
  images: '添加圖片',
  submit: '提交',
  'feedback history': '回饋列表',
  'feedback id': '單號',
  'rate our service': '為本次服務評分',
  Rated: '已評價',
  'Reasons for dissatisfaction': '不滿意的原因',
  'Please input your feedback': '請輸入您的回饋',
  processing: '處理中',
  'wait for your reply': '等待您的回復',
  'leave some comments on our service': '是否滿意我們的服務',
  collapse: '收起',
  'service detail': '回饋詳情',
  notification: '提示',
  'submit modal tip': '感謝您的回饋，我們儘快回復您',
  confirm: '確認',
  'satisfaction modal tip': `您的鼓勵將驅使我們的進步`,
  'thank rate': '感謝您的評分，您的評分將使我們提供更好的服務',
  'tip close': '一旦問題關閉後您將無法收到該回饋的回復',
  back: '返回',
  send: '發送',
  'select faq type': '選擇一個問題類型',
  'network error': '網路錯誤',

  hello: '你好,',
  'What can we do to help': '我們能做些什麼來幫助你？',
  Search: '搜索',
  'Contact Us': '聯繫我們',
  'Nothing more to load': '沒有更多的東西需要加載',
  'Search Result': '搜索問題',
  'Found {value} results': '找到{value}個結果',
  'No results for': '找不到以下項的結果',
  'Related results': '相似的問題',
  'Still need help': '還需要幫助嗎？',
  'Thanks for your feedback': '謝謝你的回饋意見!',
  'FAQ Content': 'FAQ 內容',
  'Was this article helpful': '這篇文章有幫助嗎？',
  No: '否',
  Yes: '是',
  '{min} out of {total} found this helpful':
    '{total}人中，有{min}人覺得這很有幫組。',
  'No data': '沒有數據',
  'Please fill out the form with as many details as possible':
    '請盡可能填寫下列資訊表單。',
  'feedback type': '回饋類型',
  'Select your feedback type': '選擇你的回饋類型',
  'Select your {value}': '選擇你的{value}',
  'Cannot be blank': '不能是空白',
  'Character limit exceeded': '超過了字元限制',
  'Please enter a valid email': '請輸入一個有效的電子郵件',
  success: '成功',
  fail: '失敗',
  complete: '已完成',
  error: '錯誤',
  close: '關閉',
  leave: '離開',
  stay: '留下',
  cancel: '取消',
  'You will not be able to receive a reply after it is closed':
    '關閉後，你將無法收到回復。',
  'Image uploading failed': '圖片上傳失敗',
  'Image reviewing failed': '上傳失敗，請確認圖片與問題相關且不含不當內容',
  'You can only upload a maximum of {limit} images':
    '你最多只能上傳{limit}張圖片',
  'Please check if the image format is .JPG or .PNG':
    '請檢查圖像格式是否為.JPG或.PNG。',
  'File uploading failed': '檔上傳失敗',
  'File reviewing failed': '上傳失敗，請確認文件與問題相關且不含不當內容',
  'You can only upload a maximum of {limit} files': '你最多只能上傳{limit}個檔',
  'Please check the file format': '請檢查檔格式',
  Note: '通知',
  'Do you want to submit the current feedback': '你想提交當前的回饋嗎？',
  'A customer service representative will reply within {hour} hours':
    '客戶將在{hour}小時內作出答復。',
  'This feedback will be closed. Please make a comprehensive evaluation':
    '這個回饋將關閉，你可以進一步的評價。',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    '您的回饋已因超過時間限制而結束。如果您有任何問題，請創建新的回饋。謝謝你',
  'Do you want to close the current feedback': '你想關閉當前的回饋嗎？',
  'Rate Service': '評價服務',
  'Are you satisfied with our service': '您對我們的服務滿意嗎？',
  'Thank you for your feedback! We will continue to improve our service':
    '感謝你的回饋！我們將繼續改進我們的服務',
  'You already rated this customer service less than {hour} hours ago':
    '您在不到{hour}前已經對該客戶服務進行了評價。',
  'Thank you for your feedback! We will continue to help you solve the problem':
    '謝謝你的回饋！我們將繼續幫助你解決問題。',
  'Return to top': '返回頂部',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `系統錯誤 (T_T)
請通過 {AppName} App → 幫助中心，重新打開回饋頁面。`,
  'System error. Sign expired.': '系統錯誤, 簽名過期。',
  'Network Status': '網路測速',
  Testing: '測速中',
  'Please allow us to access your network status information to help solve the issue.':
    '請允許我們採集您的網路狀態資訊，以更快更好地解決問題。',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    '網路測速中，預計需要10~30秒鐘，請等待...',
  'Done! Thank you!': '已採集完成，感謝',
  OK: '同意'
}

// 英语
const ENGLISH = {
  solved: 'Resolved',
  unsolved: 'Unresolved',
  helpful: 'Helpful',
  'not helpful': 'Not helpful',
  'tip question1': 'Hello, user',
  'tip question2': 'What do you need help with?',
  'new feedback': 'New feedback',
  more: 'More',
  feedback: 'Feedback',
  'feedback tip': 'Please fill out the form with as many details as possible',
  'question type': 'Question type',
  'email address': 'Email address',
  description: 'Description',
  images: 'Images',
  submit: 'Submit',
  'feedback history': 'Feedback history',
  'feedback id': 'Feedback ID',
  'rate our service': 'Rate our service',
  Rated: 'Rated',
  processing: 'Processing',
  'wait for your reply': 'Waiting for your reply',
  'leave some comments on our service': 'Leave a comment on our service',
  collapse: 'Collapse',
  'service detail': 'Service detail',
  notification: 'Notification',
  'submit modal tip':
    'Thank you for your feedback and we will get back to you as soon as possible.',
  confirm: 'Confirm',
  'satisfaction modal tip': `Your satisfaction is the greatest encouragement to us. 
  Rate us at the store!`,
  'thank rate': 'Thank you for your rating! We will improve our services.',
  'tip close':
    'You will no longer be able to receive a reply for this issue after it has been closed.',
  back: 'Back',
  send: 'Send',
  'select faq type': 'Select a problem type',
  'network error':
    'Your network connection is unstable. Please try again later.',

  hello: 'Hello,',
  'What can we do to help': 'What can we do to help?',
  Search: 'Search',
  'Contact Us': 'Contact Us',
  'Nothing more to load': 'Nothing more to load.',
  'Search Result': 'Search Result',
  'Found {value} results': 'Found {value} results',
  'No results for': 'No results found for',
  'Related results': 'Related results',
  'Still need help': 'Still need help?',
  'Thanks for your feedback': 'Thanks for your feedback!',
  'FAQ Content': 'FAQ Content',
  'Was this article helpful': 'Was this article helpful?',
  No: 'No',
  Yes: 'Yes',
  '{min} out of {total} found this helpful':
    '{min} out of {total} found this helpful.',
  'No data': 'No data',
  'Please fill out the form with as many details as possible':
    'Please fill out the form with as many details as possible.',
  'feedback type': 'Feedback type',
  'Select your feedback type': 'Select your feedback type',
  'Select your {value}': 'Select your {value}',
  'Cannot be blank': 'Cannot be blank',
  'Character limit exceeded': 'Character limit exceeded',
  'Please enter a valid email': 'Please enter a valid email',
  success: 'Success',
  fail: 'Failure',
  complete: 'Complete',
  error: 'Error',
  close: 'Close',
  leave: 'Leave',
  stay: 'Stay',
  cancel: 'Cancel',
  'You will not be able to receive a reply after it is closed':
    'You will not be able to receive a reply after it is closed.',
  'Image uploading failed': 'Image uploading failed',
  'Image reviewing failed': 'Upload failed. Please make sure your image is relevant and appropriate.',
  'You can only upload a maximum of {limit} images':
    'You can only upload a maximum of {limit} images',
  'Please check if the image format is .JPG or .PNG':
    'Please check if the image format is .JPG or .PNG.',
  'File uploading failed': 'File uploading failed',
  'File reviewing failed': 'Upload failed. Please make sure your file is relevant and appropriate.',
  'You can only upload a maximum of {limit} files':
    'You can only upload a maximum of {limit} files',
  'Please check the file format': 'Please check the file format',
  Note: 'Notice',
  'Do you want to submit the current feedback':
    'Do you want to submit the current feedback?',
  'A customer service representative will reply within {hour} hours':
    'A customer service representative will reply within {hour} hours.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'This feedback will be closed. Please make a comprehensive evaluation.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Your feedback has ended for exceeding the time limit. If you have any questions, please create new feedback. Thank you!',
  'Do you want to close the current feedback':
    'Do you want to close the current feedback?',
  'Rate Service': 'Rate Service',
  // 马甲站不满意反馈弹层标题；非英语翻译随后续票补齐（缺失时回落 en-US）
  'Reasons for dissatisfaction': 'Reasons for dissatisfaction',
  'Are you satisfied with our service': 'Are you satisfied with our service?',
  // 马甲站评分弹层输入框占位；非英语翻译随 08 票补齐（缺失时回落 en-US）
  'Please input your feedback': 'Please input your feedback',
  'Thank you for your feedback! We will continue to improve our service':
    'Thank you for your feedback! We will continue to improve our service.',
  'You already rated this customer service less than {hour} hours ago':
    'You already rated this customer service less than {hour} hours ago.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Thank you for your feedback! We will continue to help you solve the problem.',
  'Return to top': 'Return to top',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `System error (T_T)
Please reopen the Feedback page by going to {AppName} App → Help Center.`,
  'System error. Sign expired.': 'System error. Sign expired.',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 西语
const SPANISH = {
  solved: 'Resuelto',
  unsolved: 'Sin resolver',
  helpful: 'Útil',
  'not helpful': 'No fue útil',
  'tip question1': 'Hola, usuario',
  'tip question2': '¿Cómo te podemos ayudar?',
  'new feedback': 'Nuevo comentario',
  more: 'Más',
  feedback: 'Comentarios',
  'feedback tip':
    'Por favor, llena el formulario con tanta información como sea posible.',
  'question type': 'Tipo de pregunta',
  'email address': 'Dirección de correo electrónico',
  description: 'Descripción',
  images: 'Imágenes',
  submit: 'Enviar',
  'feedback history': 'Historial de comentarios',
  'feedback id': 'ID de comentario',
  'rate our service': 'Califica nuestro servicio',
  Rated: 'Valorado',
  'Reasons for dissatisfaction': 'Motivos de insatisfacción',
  'Please input your feedback': 'Introduce tus comentarios',
  processing: 'Procesando',
  'wait for your reply': 'Esperando por tu respuesta',
  'leave some comments on our service':
    'Deja algunos comentarios sobre nuestro servicio',
  collapse: 'Contraer',
  'service detail': 'Detalles del servicio',
  notification: 'Notificación',
  'submit modal tip':
    'Gracias por tu comentarios. Nos comunicaremos contigo tan pronto sea posible.',
  confirm: 'Confirmar',
  'satisfaction modal tip': `Tu satisfacción es nuestra mejor motivación para nuestro trabajo.
  ¡Califícanos en la Store!`,
  'thank rate':
    '¡Gracias por tu calificación! Te brindaremos un mejor servicio.',
  'tip close':
    'No podrás recibir una respuesta sobre este caso luego de que sea cerrado.',
  back: 'Regresar',
  send: 'Enviar',
  'select faq type': 'select a problem type',
  'network error':
    'Tu red es inestable. Por favor, inténtalo de nuevo más tarde.',

  hello: 'Hola,',
  'What can we do to help': '¿Qué podemos hacer para ayudar?',
  Search: 'Buscar',
  'Contact Us': 'Contáctanos',
  'Nothing more to load': 'No hay nada más que cargar.',
  'Search Result': 'Resultado de la búsqueda',
  'Found {value} results': 'Se han encontrado {value} resultados',
  'No results for': 'No hay resultados para',
  'Related results': 'Resultados relacionados',
  'Still need help': '¿Todavía necesitas ayuda?',
  'Thanks for your feedback': '¡Gracias por tus comentarios!',
  'FAQ Content': 'Contenido de Preguntas Frecuentes',
  'Was this article helpful': '¿Fue útil este artículo?',
  No: 'No',
  Yes: 'Sí',
  '{min} out of {total} found this helpful':
    '{min} de cada {total} encontraron esto útil.',
  'No data': 'No hay datos.',
  'Please fill out the form with as many details as possible':
    'Por favor, rellene el formulario con tanta información como sea posible.',
  'feedback type': 'Tipo de comentarios',
  'Select your feedback type': 'Elige tu tipo de comentario',
  'Select your {value}': 'Elija tu {value}',
  'Cannot be blank': 'No puede estar en blanco',
  'Character limit exceeded': 'Se superó el límite de caracteres',
  'Please enter a valid email':
    'Por favor, ingresa un correo electrónico válido',
  success: 'Éxito',
  fail: 'Falla',
  complete: 'Completo',
  error: 'Error',
  close: 'Cerrar',
  leave: 'Dejar',
  stay: 'Permanecer',
  cancel: 'Cancelar',
  'You will not be able to receive a reply after it is closed':
    'No podrás recibir una respuesta después de que sea cerrado.',
  'Image uploading failed': 'Error al cargar la imagen',
  'Image reviewing failed': 'Error al subir. Asegúrate de que tu imagen sea relevante y apropiada.',
  'You can only upload a maximum of {limit} images':
    'Solo puedes subir un máximo de {limit} imágenes.',
  'Please check if the image format is .JPG or .PNG':
    'Por favor, comprueba si el formato de la imagen es .JPG o .PNG.',
  'File uploading failed': 'Error al cargar la archivo',
  'File reviewing failed': 'Error al subir. Asegúrate de que tu archivo sea relevante y apropiado.',
  'You can only upload a maximum of {limit} files':
    'Solo puedes subir un máximo de {limit} archivos.',
  'Please check the file format':
    'Por favor, comprueba el formato de la archivo',
  Note: 'Atención',
  'Do you want to submit the current feedback':
    '¿Quieres enviar el comentario actual?',
  'A customer service representative will reply within {hour} hours':
    'Un representante de atención al cliente te responderá en {hour} horas.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Este comentario se cerrará. Por favor, haz una evaluación completa.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Tu comentario ha finalizado debido al tiempo de espera. Si tienes alguna pregunta, por favor, crea un nuevo comentario. ¡Gracias!',
  'Do you want to close the current feedback':
    '¿Quieres cerrar el comentario actual?',
  'Rate Service': 'Califica el Servicio',
  'Are you satisfied with our service':
    '¿Estás satisfecho con nuestro servicio?',
  'Thank you for your feedback! We will continue to improve our service':
    '¡Gracias por tus comentarios! Seguiremos mejorando nuestro servicio.',
  'You already rated this customer service less than {hour} hours ago':
    'Ya calificaste este servicio de atención al cliente hace menos de {hour} horas.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    '¡Gracias por tus comentarios! Seguiremos ayudándote a resolver el problema.',
  'Return to top': 'Ir arriba',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Error de sistema (T_T)
Por favor, ve al Centro de Ayuda, en la app de {AppName}, y abre de nuevo la página de Feedback.`,
  'System error. Sign expired.': 'Error de sistema. Firma caducada.',
  'Network Status': 'Estado de la red',
  Testing: 'Probando',
  'Please allow us to access your network status information to help solve the issue.':
    'Por favor, permítenos acceder al estado de tu red para ayudarte a resolver el problema.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'La prueba del estado de la red está en proceso. Esto puede tardar de 10 a 30 segundos. Espera por favor.',
  'Done! Thank you!': '¡Listo! ¡Gracias!',
  OK: 'OK'
}

// 德语
const GERMAN = {
  solved: 'Gelöst',
  unsolved: 'Nicht gelöst',
  helpful: 'Hilfreich',
  'not helpful': 'Nicht hilfreich',
  'tip question1': 'Hallo User',
  'tip question2': 'Womit benötigst du Hilfe?',
  'new feedback': 'Neues Feedback',
  more: 'Mehr',
  feedback: 'Feedback',
  'feedback tip': 'Bitte fülle dieses Formular so vollständig aus wie möglich.',
  'question type': 'Art der Frage',
  'email address': 'Email-Adresse',
  description: 'Beschreibung',
  images: 'Bilder',
  submit: 'Abschicken',
  'feedback history': 'Feedback-Verlauf',
  'feedback id': 'Feedback ID',
  'rate our service': 'Bewerte unseren Service',
  Rated: 'Bewertet',
  'Reasons for dissatisfaction': 'Gründe für die Unzufriedenheit',
  'Please input your feedback': 'Bitte gib dein Feedback ein',
  processing: 'In Bearbeitung',
  'wait for your reply': 'Wir warten auf deine Antwort',
  'leave some comments on our service':
    'Lass uns Feedback zu unserem Service da',
  collapse: 'Minimieren',
  'service detail': 'Einzelheiten zum Service',
  notification: 'Benachrichtigung',
  'submit modal tip': 'Danke für dein Feedback. Wir melden uns in Kürze.',
  confirm: 'Bestätigen',
  'satisfaction modal tip':
    'Deine Zufriedenheit ist unser größter Antrieb. Bewerte uns im Store!',
  'thank rate':
    'Danke für deine Bewertung! Wir werden uns bemühen, unseren Service zu verbessern.',
  'tip close':
    'Nachdem diese Unterhaltung geschlossen wurde, wirst du keine Antworten mehr dazu erhalten können.',
  back: 'Zurück',
  send: 'Senden',
  'select faq type': 'select a problem type',
  'network error':
    'Deine Internetverbindung ist schlecht. Bitte versuche es später erneut.',

  hello: 'Hallo,',
  'What can we do to help': 'Was können wir tun, um zu helfen?',
  Search: 'Suche',
  'Contact Us': 'Kontaktieren uns',
  'Nothing more to load': 'Suche beendet.',
  'Search Result': 'Suchergebnis',
  'Found {value} results': '{value} Ergebnisse gefunden',
  'No results for': 'Keine Ergebnisse für',
  'Related results': 'Verwandte Suchergebnisse',
  'Still need help': 'Brauche du noch Hilfe?',
  'Thanks for your feedback': 'Vielen Dank für dein Feedback!',
  'FAQ Content': 'FAQ Inhalt',
  'Was this article helpful': 'War dieser Artikel hilfreich?',
  No: 'Nein',
  Yes: 'Ja',
  '{min} out of {total} found this helpful':
    '{min} von {total} fanden dies hilfreich',
  'No data': 'Keine weiteren Angaben.',
  'Please fill out the form with as many details as possible':
    'Bitte fülle dieses Formular so vollständig aus wie möglich.',
  'feedback type': 'Anfrage-Typ',
  'Select your feedback type': 'Bitte wähle deinen Anfrage-Typ',
  'Select your {value}': 'Bitte wähle deinen {value}',
  'Cannot be blank': 'Darf nicht leer sein',
  'Character limit exceeded': 'Zeichenlimit überschritten',
  'Please enter a valid email': 'Bitte gib eine gültige E-Mail Adresse ein',
  success: 'Erfolg',
  fail: 'Fehlgeschlagen',
  complete: 'Fertig',
  error: 'Fehler',
  close: 'Schließen',
  leave: 'Verlassen',
  stay: 'Bleiben',
  cancel: 'Abbrechen',
  'You will not be able to receive a reply after it is closed':
    'Nachdem diese Unterhaltung geschlossen wurde, wirst du keine Antworten mehr dazu erhalten können.',
  'Image uploading failed': 'Bild-Upload fehlgeschlagen',
  'Image reviewing failed': 'Upload fehlgeschlagen. Bitte stelle sicher, dass dein Bild relevant und angemessen ist.',
  'You can only upload a maximum of {limit} images':
    'Du kannst nur maximal {limit} Bilder hochladen.',
  'Please check if the image format is .JPG or .PNG':
    'Bitte prüfe, ob das Bildformat JPG oder PNG ist.',
  'File uploading failed': 'Datei-Upload fehlgeschlagen',
  'File reviewing failed': 'Upload fehlgeschlagen. Bitte stelle sicher, dass dein Datei relevant und angemessen ist.',
  'You can only upload a maximum of {limit} files':
    'Du kannst nur maximal {limit} Files hochladen.',
  'Please check the file format': 'Bitte prüfe, ob das Dateiformat.',
  Note: 'Achtung',
  'Do you want to submit the current feedback':
    'Soll die aktuelle Anfrage übermittelt werden?',
  'A customer service representative will reply within {hour} hours':
    'Der Kundenservice wird innerhalb von {hour} Stunden antworten.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Diese Anfrage wird nun geschlossen, bitte gib eine Gesamtbewertung ab.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Deine Anfrage ist abgelaufen. Hast du weitere Fragen? Erstelle gern eine neue Feedback-Anfrage. Danke!',
  'Do you want to close the current feedback':
    'Soll die aktuelle Anfrage geschlossen werden?',
  'Rate Service': 'Service-Bewertung',
  'Are you satisfied with our service':
    'Bist du mit unserem Service zufrieden?',
  'Thank you for your feedback! We will continue to improve our service':
    'Vielen Dank für dein Feedback, wir werden den Service weiter verbessern.',
  'You already rated this customer service less than {hour} hours ago':
    'Du hast deine Erfahrung mit unserem Kundendienst vor weniger als {hour} Stunden schon einmal bewertet.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Vielen Dank für dein Feedback, wir werden weiterhin alles daran setzen, das Problem zu lösen.',
  'Return to top': 'Zurück zum Anfang',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Systemfehler (T_T)
Bitte öffne die Feedback-Seite erneut, indem du zu {AppName} App → Help Center gehst.`,
  'System error. Sign expired.': 'Systemfehler. Unterschrift abgelaufen.',
  'Network Status': 'Netzwerk-Status',
  Testing: 'Wird getestet',
  'Please allow us to access your network status information to help solve the issue.':
    'Bitte erlaube uns, auf deine Netzwerkstatus-Informationen zuzugreifen, um das Problem zu lösen.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Der Netzwerktest wird gerade durchgeführt. Es kann 10-30 Sekunden dauern. Bitte warten.',
  'Done! Thank you!': 'Erledigt! Vielen Dank!',
  OK: 'OK'
}

// 俄罗斯语
const RUSSIAN = {
  solved: 'Решена',
  unsolved: 'Не решена',
  helpful: 'Помог',
  'not helpful': 'Не помог',
  'tip question1': 'Здравствуйте, уважаемый пользователь ',
  'tip question2': `Чем мы можем вам помочь?`,
  'new feedback': 'Новое обращение',
  more: 'Еще',
  feedback: 'Обращение',
  'feedback tip': 'Пожалуйста, заполните форму максимально подробно.',
  'question type': 'Тип  проблемы',
  'email address': 'Email',
  description: 'Описание проблемы',
  images: 'Скриншоты',
  submit: 'Отправить',
  'feedback history': 'История обращений',
  'feedback id': 'Номер обращения',
  'rate our service': 'Оцените нашу работу',
  Rated: 'Оценено',
  'Reasons for dissatisfaction': 'Причины недовольства',
  'Please input your feedback': 'Пожалуйста, введите ваш отзыв',
  processing: 'В обработке',
  'wait for your reply': 'Ожидает вашего ответа',
  'leave some comments on our service': 'Оцените работу нашей службы поддержки',
  collapse: 'Скрыть',
  'service detail': 'Информация об услугах',
  notification: 'Уведомление',
  'submit modal tip': 'Спасибо за ваше обращение. Мы скоро с вами свяжемся.',
  confirm: 'Подтвердить',
  'satisfaction modal tip': `Ваше мнение - лучший стимул для нашей работы.
  Оцените наше приложение!`,
  'thank rate':
    'Спасибо, что поставили нам оценку! Для нас важно, чтобы вы оказались довольны.',
  'tip close':
    'Вы больше не будете получать сообщения по этому обращению после того, как оно будет закрыто.',
  back: 'Вернуться',
  send: 'Отправить',
  'select faq type': 'select a problem type',
  'network error':
    'Слабый сигнал подключения к сети. Пожалуйста, повторите попытку позже.',

  hello: 'Здравствуйте,',
  'What can we do to help': 'Что мы можем сделать, чтобы помочь?',
  Search: 'Поиск',
  'Contact Us': 'Свяжитесь с нами',
  'Nothing more to load': 'Больше нечего загружать.',
  'Search Result': 'Результат поиска',
  'Found {value} results': 'Найдено {value} результатов',
  'No results for': 'Нет результатов для',
  'Related results': 'Полученные результаты',
  'Still need help': 'Все еще нужна помощь?',
  'Thanks for your feedback': 'Спасибо за ваш отзыв!',
  'FAQ Content': 'Часто задаваемые вопросы',
  'Was this article helpful': 'Была ли эта статья полезной?',
  No: 'Нет',
  Yes: 'Да',
  '{min} out of {total} found this helpful':
    '{min} из {total} чел. нашли эту статью полезной',
  'No data': 'Больше никаких данных.',
  'Please fill out the form with as many details as possible':
    'Пожалуйста, заполните форму как можно более подробной информацией.',
  'feedback type': 'Тип обратной связи',
  'Select your feedback type': 'Выберите тип обратной связи',
  'Select your {value}': 'Выберите {value}',
  'Cannot be blank': 'Не может быть пустым',
  'Character limit exceeded': 'Лимит символов превышен',
  'Please enter a valid email':
    'Пожалуйста, введите действующий адрес электронной почты',
  success: 'Успешно',
  fail: 'Безуспешно',
  complete: 'Завершить',
  error: 'Ошибка',
  close: 'Закрыть',
  leave: 'Покинуть',
  stay: 'Остаться',
  cancel: 'Отменить',
  'You will not be able to receive a reply after it is closed':
    'Вы не сможете получить ответ на вопрос после его закрытия.',
  'Image uploading failed': 'Ошибка загрузки изображения',
  'Image reviewing failed': 'Не удалось загрузить. Убедитесь, что изображение уместно и подходит по теме.',
  'You can only upload a maximum of {limit} images':
    'Вы можете загрузить не более {limit} изображений.',
  'Please check if the image format is .JPG or .PNG':
    'Пожалуйста, убедитесь, что форматом ваших изображения является JPG или PNG.',
  'File uploading failed': 'Ошибка загрузки Файл',
  'File reviewing failed': 'Не удалось загрузить. Убедитесь, что файл уместно и подходит по теме.',
  'You can only upload a maximum of {limit} files':
    'Вы можете загрузить не более {limit} Файлы.',
  'Please check the file format':
    'Пожалуйста, убедитесь, что форматом ваших Файл.',
  Note: 'Примечание',
  'Do you want to submit the current feedback':
    'Вы хотите отправить текущее обращение?',
  'A customer service representative will reply within {hour} hours':
    'Служба поддержки ответит в течение {hour} часов',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Это обращение будет закрыто. Пожалуйста, поставьте общую оценку.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Время для вашего обращения истекло. Пожалуйста, если у вас есть вопросы, создайте новое обращение. Спасибо.',
  'Do you want to close the current feedback':
    'Вы уверены, что хотите закрыть текущее обращение?',
  'Rate Service': 'Оценка сервиса',
  'Are you satisfied with our service': 'Вы довольны нашей службой поддержки?',
  'Thank you for your feedback! We will continue to improve our service':
    'Спасибо за отзыв! Мы продолжим улучшать наш сервис.',
  'You already rated this customer service less than {hour} hours ago':
    'Вы уже оценили сервис менее {hour} час. назад.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Спасибо за отзыв! Мы продолжим помогать вам в решении проблем.',
  'Return to top': 'вернуться к началу',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Системная ошибка (T_T)
Пожалуйста, откройте снова страницу обратной связи, перейдя в раздел приложения {AppName} → Помощь.`,
  'System error. Sign expired.':
    'Системная ошибка. Срок действия подписи истек.',
  'Network Status': 'Состояние сети',
  Testing: 'Тестирование',
  'Please allow us to access your network status information to help solve the issue.':
    'Пожалуйста, позвольте нам получить доступ к информации о состоянии вашей сети, чтобы помочь решить проблему.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Идет тестирование сети. Это может занять 10-30 секунд. Пожалуйста, подождите.',
  'Done! Thank you!': 'Готово! Спасибо!',
  OK: 'OK'
}

// 法语
const FRENCH = {
  solved: 'Résolu',
  unsolved: 'Non résolu',
  helpful: 'Utile',
  'not helpful': 'Inutile',
  'tip question1': 'Salut, cher utilisateur.',
  'tip question2': `Comment pouvons-nous t'aider ?`,
  'new feedback': 'Nouveaux commentaires',
  'cm1009.fr.new feedback': "Nouveau retour d'information",
  more: 'Plus',
  feedback: 'Commentaires',
  'cm1009.fr.feedback': 'rétroaction',
  'feedback tip': `Remplis ce formulaire en incluant le plus d'informations possible.`,
  'question type': 'Type de question',
  'email address': 'Mail',
  description: 'Description',
  images: 'Images',
  submit: 'Soumettre',
  'feedback history': 'Historique des commentaires',
  'feedback id': 'ID Commentaires',
  'rate our service': 'Évalue notre service',
  Rated: 'Évalué',
  'Reasons for dissatisfaction': "Motifs d'insatisfaction",
  'Please input your feedback': 'Saisis ton commentaire',
  processing: 'En traitement',
  'wait for your reply': 'En attente de ta réponse',
  'leave some comments on our service':
    'Laisse un commentaire sur notre service',
  collapse: 'Revenir en arrière',
  'service detail': 'Détails du service',
  notification: 'Notification',
  'submit modal tip':
    'Merci pour tes commentaires. Nous te répondrons le plus rapidement possible.',
  confirm: 'Confirmer',
  'satisfaction modal tip': `Ta satisfaction est la meilleure façon de récompenser notre travail. Donne-nous une note dans l'App Store!`,
  'thank rate': `Merci pour ta note! Nous serons maintenant en mesure de t'offrir un meilleur service.`,
  'tip close': `Tu ne recevras plus de notification en lien avec ce problème une fois qu'il aura été résolu.`,
  back: 'Retour',
  send: 'Envoyer',
  'select faq type': 'select a problem type',
  'network error': 'Ta connexion est instable. Merci de réessayer plus tard.',

  hello: 'Bonjour,',
  'What can we do to help': 'Que pouvons-nous faire pour aider ?',
  Search: 'Rechercher',
  'Contact Us': 'Nous contacter',
  'Nothing more to load': 'Rien de plus à charger.',
  'Search Result': 'Résultat de la recherche',
  'Found {value} results': '{value} résultats trouvés',
  'No results for': 'Aucun résultat pour',
  'Related results': 'Résultats associés',
  'Still need help': "Encore besoin d'aide ?",
  'Thanks for your feedback': 'Merci pour tes commentaires !',
  'FAQ Content': 'Contenu de la FAQ',
  'Was this article helpful': 'Cet article a-t-il été utile ?',
  No: 'Non',
  Yes: 'Oui',
  '{min} out of {total} found this helpful':
    'Cet article a été utile pour {min} sur {total}.',
  'No data': 'Aucune donnée.',
  'Please fill out the form with as many details as possible':
    "Remplis ce formulaire en incluant le plus d'informations possible.",
  'feedback type': 'Type de commentaires',
  'Select your feedback type': 'Choisis le type de ton commentaire',
  'Select your {value}': 'Choisis ton {value}',
  'cm1009.fr.Select your {value}': 'Sélectionnez votre {value}',
  'Cannot be blank': 'Tu dois remplir ce champ',
  'Character limit exceeded': 'Limite de caractères dépassée',
  'Please enter a valid email': 'Merci de saisir une adresse e-mail valide',
  'cm1009.fr.Please enter a valid email':
    'Veuillez entrer une adresse e-mail valide',
  success: 'Succès',
  fail: 'Échec',
  complete: 'Terminé',
  error: 'Erreur',
  close: 'Fermer',
  leave: 'Quitter',
  stay: 'Rester',
  cancel: 'Annuler',
  'You will not be able to receive a reply after it is closed':
    "Tu ne recevras plus de notification en lien avec ce problème une fois qu'il aura été résolu.",
  'Image uploading failed': "Échec du téléchargement de l'image",
  'Image reviewing failed': 'Échec du téléversement. Assurez-vous que votre image est pertinente et appropriée.',
  'You can only upload a maximum of {limit} images':
    "Tu ne peux télécharger qu'un maximum de {limit} images.",
  'Please check if the image format is .JPG or .PNG':
    "Vérifie si le format de l'image est JPG ou PNG.",
  'File uploading failed': "Échec du téléchargement de l'Fichier",
  'File reviewing failed': "Échec du téléversement. Assurez-vous que votre fichier est pertinent et approprié.",
  'cm1009.fr.File uploading failed': 'Le téléchargement du fichier a échoué',
  'You can only upload a maximum of {limit} files':
    "Tu ne peux télécharger qu'un maximum de {limit} Fichiers.",
  'cm1009.fr.You can only upload a maximum of {limit} files':
    "Vous ne pouvez télécharger qu'un maximum de {limit} fichiers.",
  'Please check the file format': "Vérifie le format de l'Fichier.",
  'cm1009.fr.Please check the file format':
    'Veuillez vérifier le format du fichier',
  Note: 'Noter',
  'Do you want to submit the current feedback':
    'Veux-tu soumettre ce commentaire ?',
  'A customer service representative will reply within {hour} hours':
    'Un représentant du service client répondra dans les {hour} prochaines heures.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    "Fais une évaluation globale de ce commentaire puisqu'il sera fermé.",
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    "Ton commentaire s'est terminé en raison du délai de rédaction trop long. Si tu as des questions, crée un nouveau commentaire, merci.",
  'Do you want to close the current feedback':
    'Veux-tu fermer ce commentaire ?',
  'Rate Service': 'Évaluer le service',
  'Are you satisfied with our service': 'Es-tu satisfait du service reçu ?',
  'Thank you for your feedback! We will continue to improve our service':
    'Merci pour ton commentaire ; il nous permettra de continuer à améliorer notre service.',
  'You already rated this customer service less than {hour} hours ago':
    'Tu as noté ce service client il y a moins de {hour} heures.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Merci pour ton commentaire ; il nous aidera à résoudre le problème.',
  'Return to top': 'Retour au début',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Erreur système (T_T)
S'il te plaît, rouvre la page des commentaires en allant dans l'App {AppName} → Centre d'aide.`,
  'cm1009.fr.System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Erreur système (T_T)
Veuillez rouvrir la page de commentaires en allant dans l'application {AppName} → Centre d'aide`,
  'System error. Sign expired.': 'Erreur système. Le signe a expiré.',
  'cm1009.fr.System error. Sign expired.': 'Erreur système. Signature expirée',
  'Network Status': 'État du réseau',
  Testing: 'Vérification',
  'Please allow us to access your network status information to help solve the issue.':
    "Veuillez nous donner accès aux informations liées à l'état de votre réseau afin de nous aider à résoudre le problème.",
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'La vérification du réseau est en cours. Cette opération peut prendre de 10 à 30 secondes. Merci de patienter.',
  'Done! Thank you!': 'Terminé! Merci!',
  OK: "D'accord"
}

// 葡语
const PORTUGUESE = {
  solved: 'Resolvido',
  unsolved: 'Não resolvido',
  helpful: 'Útil',
  'not helpful': 'Inútil',
  'tip question1': 'Olá, usuário',
  'tip question2': 'Como podemos te ajudar?',
  'new feedback': 'Novo feedback',
  more: 'Mais',
  feedback: 'Comentários',
  'feedback tip':
    'Por favor, preencha o formulário com o máximo de informações possível.',
  'feedback history': 'Histórico de feedback',
  'feedback id': 'ID do feedback',
  'rate our service': 'Avalie nosso serviço',
  Rated: 'Avaliado',
  'Reasons for dissatisfaction': 'Motivos de insatisfação',
  'Please input your feedback': 'Insira o seu feedback',
  processing: 'Em processamento',
  'wait for your reply': 'Aguardando sua resposta',
  'leave some comments on our service':
    'Deixe algum comentário sobre nosso serviço',
  collapse: 'Ocultar',
  'question type': 'Tipo de pergunta',
  'email address': 'Endereço de e-mail',
  description: 'Descrição',
  images: 'Imagens',
  submit: 'Enviar',
  'service detail': 'Detalhes do serviço',
  notification: 'Notificação',
  'submit modal tip':
    'Obrigado pelo seu feedback. Entraremos em contato com você o mais brevemente possível.',
  confirm: 'Confirmar',
  'satisfaction modal tip':
    'A sua satisfação é o maior incentivo para o nosso trabalho.',
  'thank rate':
    'Agradecemos sua avaliação! Nossa satisfação é oferecer o melhor serviço possível.',
  'tip close':
    'Não será mais possível receber uma resposta sobre este problema uma vez que ele for finalizado.',
  back: 'Voltar',
  send: 'Enviar',
  'select faq type': 'select a problem type',
  'network error':
    'Sua rede está instável. Por favor, tente novamente mais tarde.',

  hello: 'Olá,',
  'What can we do to help': 'O que podemos fazer para ajudar?',
  Search: 'Pesquisar',
  'Contact Us': 'Entre em contato conosco',
  'Nothing more to load': 'Nada mais para carregar.',
  'Search Result': 'Resultado da pesquisar',
  'Found {value} results': 'Pesquisa de {value} resultados',
  'No results for': 'Sem resultados para',
  'Related results': 'Resultados relacionados',
  'Still need help': 'Ainda precisa de ajuda?',
  'Thanks for your feedback': 'Agradecemos pelo seu feedback!',
  'FAQ Content': 'Conteúdo das FAQ',
  'Was this article helpful': 'Este artigo foi útil?',
  No: 'Não',
  Yes: 'Sim',
  '{min} out of {total} found this helpful':
    '{min} em cada {total} achou isto útil.',
  'No data': 'Nada há dados.',
  'Please fill out the form with as many details as possible':
    'Por favor, preencha o formulário com o máximo de informações possível.',
  'feedback type': 'Tipo de feedback',
  'Select your feedback type': 'Escolha o seu tipo de feedback',
  'Select your {value}': 'Escolha o seu {value}',
  'Cannot be blank': 'Não pode estar em branco',
  'Character limit exceeded': 'Limite de caracteres excedido',
  'Please enter a valid email':
    'Por favor, insira um endereço de e-mail válido',
  success: 'Sucesso',
  fail: 'Falha',
  complete: 'Completo',
  error: 'Erro',
  close: 'Fechar',
  leave: 'Sair',
  stay: 'Ficar',
  cancel: 'Cancelar',
  'You will not be able to receive a reply after it is closed':
    'Não poderá receber uma resposta para problema depois que ele for encerrado.',
  'Image uploading failed': 'Falha no carregamento de imagens',
  'Image reviewing failed': 'Falha no upload. Certifique-se de que sua imagem é relevante e apropriada.',
  'You can only upload a maximum of {limit} images':
    'Só se pode carregar um máximo de {limit} imagens.',
  'Please check if the image format is .JPG or .PNG':
    'Por favor, verifique se o formato da imagem é .JPG ou .PNG.',
  'File uploading failed': 'Falha no carregamento de ficheiro',
  'File reviewing failed': 'Falha no upload. Certifique-se de que seu ficheiro é relevante e apropriado.',
  'You can only upload a maximum of {limit} files':
    'Só se pode carregar um máximo de {limit} ficheiros.',
  'Please check the file format': 'Por favor, verifique o formato da ficheiro.',
  Note: 'Atenção',
  'Do you want to submit the current feedback': 'Quer enviar este feedback?',
  'A customer service representative will reply within {hour} hours':
    'O SAC responderá no prazo de {hour} horas.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Este feedback será encerrado, por favor, faça uma avaliação geral.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Seu tempo expirou, se tiver alguma dúvida, por favor, crie um novo feedback. Obrigado!',
  'Do you want to close the current feedback': 'Quer encerrar este feedback?',
  'Rate Service': 'Classificação do Serviço',
  'Are you satisfied with our service': 'Está satisfeito com o nosso serviço',
  'Thank you for your feedback! We will continue to improve our service':
    'Obrigado pelo seu feedback! Vamos continuar melhorando.',
  'You already rated this customer service less than {hour} hours ago':
    'Você já avaliou este atendimento há menos de {hour} horas.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Obrigado pelo seu feedback! Continuaremos ajudando você a resolver o problema.',
  'Return to top': 'Voltar ao topo',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Erro no sistema (T_T)
Por favor, abra a página Feedback através da Central de Ajuda no aplicativo do {AppName}.`,
  'System error. Sign expired.': 'Erro no sistema. O sinal expirou.',
  'Network Status': 'Estado da Rede',
  Testing: 'Verificação',
  'Please allow us to access your network status information to help solve the issue.':
    'É necessário autorizar o acesso ao estado de sua rede para nos ajudar a resolver o problema.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'A verificação da rede está em andamento. Pode levar de 10 a 30 segundos. Por favor, aguarde.',
  'Done! Thank you!': 'Concluído!',
  OK: 'Ok'
}

// 韩语
const KOREAN = {
  solved: '해결됨',
  unsolved: '해결 안 됨',
  helpful: '도움이 됨',
  'not helpful': '도움이 안 됨',
  'tip question1': '안녕하세요, 사용자님.',
  'tip question2': '어떤 도움이 필요하십니까?',
  'new feedback': '새 피드백',
  more: '더 보기',
  feedback: '피드백',
  'feedback tip': '아래의 서식을 최대한 많은 정보로 채워주세요',
  'feedback history': '피드백 기록',
  'feedback id': '피드백 아이디',
  'rate our service': '저희 서비스를 평가해 주세요.',
  Rated: '평가 완료',
  'Reasons for dissatisfaction': '불만족 이유',
  'Please input your feedback': '의견을 입력해 주세요',
  processing: '해결 중',
  'wait for your reply': '사용자님의 답변을 기다리는 중',
  'leave some comments on our service': '저희의 서비스에 의견을 남겨 주세요.',
  collapse: '최소화하기',
  'question type': '문의 유형',
  'email address': '이메일 주소',
  description: '설명',
  images: '이미지',
  submit: '제출하기',
  'service detail': '서비스 세부 사항',
  notification: '알림',
  'submit modal tip':
    '귀하의 피드백에 감사드리며, 최대한 빨리 연락드리겠습니다.',
  confirm: '확인',
  'satisfaction modal tip': `귀하의 만족도는 저희가 더 열심히 일할 수 있는 원동력입니다. 
  앱 스토어에 리뷰를 남겨 주세요!`,
  'thank rate': '평가해 주셔서 감사합니다! 더 나은 서비스로 보답하겠습니다.',
  'tip close':
    '창을 닫고 나면 이 문제에 대해 더 이상의 답변을 받을 수 없습니다.',
  back: '뒤로 가기',
  send: '보내기',
  'select faq type': 'select a problem type',
  'network error': '네트워크가 불안정하기에 나중에 다시 시도하십시오.',

  hello: '안녕하세요,',
  'What can we do to help': '무엇을 도와 드릴까요?',
  Search: '검색',
  'Contact Us': '문의하기',
  'Nothing more to load': '더 이상 로드할 항목이 없습니다.',
  'Search Result': '검색 결과',
  'Found {value} results': '{value} 개의 결과 검색',
  'No results for': '에 대한 검색 결과가 없습니다',
  'Related results': '관련 결과',
  'Still need help': '여전히 도움이 필요합니다',
  'Thanks for your feedback': '귀하의 의견에 감사드립니다',
  'FAQ Content': 'FAQ 내용',
  'Was this article helpful': '이 글이 도움 되었나요?',
  No: '아니오',
  Yes: '예',
  '{min} out of {total} found this helpful':
    '{total} 명 중 {min} 명이 도움이 되었다고 했습니다',
  'No data': '더 이상 데이터 없음',
  'Please fill out the form with as many details as possible':
    '가능한 한 간단한 정보로 양식을 작성하십시오.',
  'feedback type': '피드백 유형',
  'Select your feedback type': '피드백 유형 선택',
  'Select your {value}': '{value}을 선택하세요',
  'Cannot be blank': '비워 둘 수 없습니다',
  'Character limit exceeded': '글자 수가 한도를 초과했습니다',
  'Please enter a valid email': '유효한 이메일 주소를 입력해주세요',
  success: '성공',
  fail: '실패',
  complete: '완료',
  error: '오류',
  close: '닫기',
  leave: '떠나기',
  stay: '머무르기',
  cancel: '취소',
  'You will not be able to receive a reply after it is closed':
    '문의가 종료된 후에는 문제에 관한 답장을 받을 수 없습니다.',
  'Image uploading failed': '이미지 업로드 실패',
  'Image reviewing failed': '업로드 실패. 이미지가 관련 있고 부적절하지 않은지 확인하세요.',
  'You can only upload a maximum of {limit} images':
    '최대 {limit} 개의 이미지만 업로드할 수 있습니다.',
  'Please check if the image format is .JPG or .PNG':
    '이미지 형식이 JPG, PNG인지 확인하세요.',
  'File uploading failed': '파일 업로드 실패',
  'File reviewing failed': '업로드 실패. 파일이 관련 있고 부적절하지 않은지 확인하세요.',
  'You can only upload a maximum of {limit} files':
    '최대 {limit} 개의 파일만 업로드할 수 있습니다.',
  'Please check the file format': '파일 형식을 확인하십시오.',
  Note: '주의',
  'Do you want to submit the current feedback':
    '현재 피드백을 제출하시겠습니까?',
  'A customer service representative will reply within {hour} hours':
    '고객 상담사가 {hour} 시간 이내에 답변을 드립니다.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    '이 피드백은 종료됩니다. 전체적인 평가를 부탁드립니다.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    '귀하의 상담은 시간이 만료되어 종료되었습니다. 질문이 있으시면 새 피드백을 작성하십시오. 감사합니다.',
  'Do you want to close the current feedback': '현재 피드백을 닫을까요?',
  'Rate Service': '서비스 평가',
  'Are you satisfied with our service': '우리의 서비스에 만족하십니까?',
  'Thank you for your feedback! We will continue to improve our service':
    '의견을 보내 주셔서 감사합니다. 계속해서 서비스를 개선하겠습니다.',
  'You already rated this customer service less than {hour} hours ago':
    '이미 {hour} 시간 전에 평가를 마친 서비스입니다.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    '의견을 보내주셔서 감사합니다! 계속해서 고객님의 문제를 해결하는 데 도와드리겠습니다.',
  'Return to top': '처음으로 돌아가기',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `시스템 오류입니다 (T_T)
{AppName} 앱으로 이동한 후, 도움말로 가서 피드백 페이지를 다시 열어주세요.`,
  'System error. Sign expired.': '시스템 오류입니다. 서명이 만료되었습니다.',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 意语
const ITALIAN = {
  solved: 'Risolto',
  unsolved: 'Non risolto',
  helpful: 'Utile',
  'not helpful': 'Non utile',
  'tip question1': 'Caro utente,',
  'tip question2': 'Come possiamo aiutarti?',
  'new feedback': 'Nuovo feedback',
  more: 'Di più',
  feedback: 'Feedback',
  'feedback tip':
    'Ti preghiamo di compilare il modulo con il maggior numero di informazioni possibile. ',
  'feedback history': 'Cronologia del feedback',
  'feedback id': 'ID del feedback ',
  'rate our service': 'Valuta la nostra assistenza',
  Rated: 'Valutato',
  'Reasons for dissatisfaction': 'Motivi di insoddisfazione',
  'Please input your feedback': 'Inserisci il tuo feedback',
  processing: 'In elaborazione',
  'wait for your reply': 'In attesa della tua risposta',
  'leave some comments on our service':
    'Lascia un commento sulla nostra assistenza',
  collapse: 'Nascondi',
  'question type': 'Tipologia domanda',
  'email address': 'Indirizzo email',
  description: 'Descrizione',
  images: 'Immagini',
  submit: 'Inoltra',
  'service detail': 'Dettagli',
  notification: 'Notifiche',
  'submit modal tip':
    'Grazie per il tuo feedback, ti risponderemo il prima possibile.',
  confirm: 'Conferma',
  'satisfaction modal tip': `La tua  soddisfazione è il miglior incoraggiamento per il nostro lavoro. 
  Valuta la nostra app sullo Store! `,
  'thank rate':
    'Grazie per aver valutato la nostra app! Ci impegneremo per fornirti un servizio migliore.',
  'tip close':
    'Una volta chiuso, non sarà più possibile ricevere una risposta per questo problema.',
  back: 'Annulla',
  send: 'Inoltra',
  'select faq type': 'select a problem type',
  'network error':
    'La tua rete è instabile. Ti preghiamo di riprovare più tardi.',

  hello: 'Ciao,',
  'What can we do to help': 'Cosa possiamo fare per aiutare?',
  Search: 'Cerca',
  'Contact Us': 'Contattaci',
  'Nothing more to load': 'Niente da caricare.',
  'Search Result': 'Risultato della ricerca',
  'Found {value} results': 'Trovati {value} risultati',
  'No results for': 'Nessun risultato per',
  'Related results': 'Risultati correlati',
  'Still need help': 'Hai ancora bisogno di aiuto?',
  'Thanks for your feedback': 'Grazie per il tuo feedback!',
  'FAQ Content': 'Contenuto FAQ',
  'Was this article helpful': 'Questo articolo è stato utile?',
  No: 'No',
  Yes: 'Sì',
  '{min} out of {total} found this helpful':
    '{min} su {total} lo ha trovato utile.',
  'No data': 'Nessun dato.',
  'Please fill out the form with as many details as possible':
    'Si prega di compilare il modulo con il maggior numero di informazioni possibili.',
  'feedback type': 'Tipo di messaggio',
  'Select your feedback type': 'Scegli la tipologia di messaggio',
  'Select your {value}': 'Scegli la {value}',
  'Cannot be blank': 'Non può essere vuoto',
  'Character limit exceeded':
    'Il numero di caratteri supera il limite consentito',
  'Please enter a valid email':
    'Ti preghiamo di inserire un indirizzo email valido',
  success: 'Successo',
  fail: 'Non riuscito',
  complete: 'Completo',
  error: 'Errore',
  close: 'Chiudi',
  leave: 'Esci',
  stay: 'Rimani',
  cancel: 'Cancella',
  'You will not be able to receive a reply after it is closed':
    'Non potrai più ricevere una risposta al problema dopo averlo chiuso.',
  'Image uploading failed': 'Caricamento immagine fallito',
  'Image reviewing failed': `Caricamento non riuscito. Assicurati che l'immagine sia pertinente e appropriata.`,
  'You can only upload a maximum of {limit} images':
    'Puoi caricare solo un massimo di {limit} immagini.',
  'Please check if the image format is .JPG or .PNG':
    "Controlla se l'immagine è nei formati JPG, PNG.",
  'File uploading failed': 'Caricamento file fallito',
  'File reviewing failed': 'Caricamento non riuscito. Assicurati che il tuo file sia pertinente e appropriato.',
  'You can only upload a maximum of {limit} files':
    'Puoi caricare solo un massimo di {limit} file.',
  'Please check the file format': "Controlla l'file formati.",
  Note: 'Attenzione',
  'Do you want to submit the current feedback':
    'Desideri inviare questo messaggio?',
  'A customer service representative will reply within {hour} hours':
    'Il servizio clienti risponderà entro {hour} ore.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Questo ticket verrà chiuso. Si prega di valutare il servizio ricevuto.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Tempo scaduto. Per contattarci, devi aprire un nuovo ticket, grazie.',
  'Do you want to close the current feedback': 'Vuoi chiudere questo ticket?',
  'Rate Service': 'Valutazione del servizio',
  'Are you satisfied with our service': 'Sei soddisfatto del nostro servizio?',
  'Thank you for your feedback! We will continue to improve our service':
    'Grazie per il tuo feedback, continueremo a migliorare il nostro servizio.',
  'You already rated this customer service less than {hour} hours ago':
    'Hai già valutato il nostro servizio clienti meno di {hour} ore fa.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Grazie per il tuo feedback, continueremo a lavorare per risolvere il problema.',
  'Return to top': 'Torna all’inizio',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Errore di sistema (T_T)
Ti preghiamo di riaprire la pagina ‘Feedback’ andando nella sezione ‘Aiuto’ dell’app {AppName}.`,
  'System error. Sign expired.': 'Errore di sistema. Firma scaduta.',
  'Network Status': 'Stato della rete',
  Testing: 'Verifica in corso',
  'Please allow us to access your network status information to help solve the issue.':
    'Consentici di accedere alle informazioni sullo stato della rete per risolvere il problema.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Il test della rete è in corso. Potrebbe essere necessario attendere 10-30 secondi.',
  'Done! Thank you!': 'Fatto! Grazie!',
  OK: 'OK'
}

// 日语
const JAPANESE = {
  solved: '解決済',
  unsolved: '未解決',
  helpful: '参考になった',
  'not helpful': '解決に不充分',
  'tip question1': 'こんにちは、ユーザーさん',
  'tip question2': 'どのような用件ですか？',
  'new feedback': '新しいフィードバック',
  more: '詳しい情報を見る',
  feedback: 'ご意見',
  'feedback tip': '気になった点などございましたらご記入ください。',
  'feedback history': 'フィードバック履歴',
  'feedback id': 'フィードバック番号',
  'rate our service': '評価する',
  Rated: '評価済み',
  'Reasons for dissatisfaction': 'ご不満の理由',
  'Please input your feedback': 'ご意見を入力してください',
  processing: '処理中',
  'wait for your reply': '返信をお待ちしています',
  'leave some comments on our service': '評価をお願いします',
  collapse: '閉じる',
  'question type': '問題の種類',
  'email address': 'メールアドレス',
  description: '詳細',
  images: '添付画像',
  submit: '送信',
  'service detail': 'サービス内容',
  notification: 'お知らせ',
  'submit modal tip':
    'フィードバックありがとうございます。後ほどご連絡致します。',
  confirm: '確認',
  'satisfaction modal tip':
    'ご意見ありがとうございます。ご評価頂けますうようお願いします。',
  'thank rate':
    '評価頂ありがとうございます。今後の品質評価の参考にさせていただきます。',
  'tip close': '問題がクローズされると、回答はされません。',
  back: '戻る',
  send: '送信',
  'select faq type': 'select a problem type',
  'network error': 'ネットワークエラー。',

  hello: 'こんにちは,',
  'What can we do to help': 'どのようなご用件ですか？',
  Search: '検索',
  'Contact Us': 'お問い合わせ',
  'Nothing more to load': 'これ以上の読み込みはありません',
  'Search Result': '検索結果',
  'Found {value} results': '{value} 件の検索結果',
  'No results for': 'の結果はありません',
  'Related results': '関連する結果',
  'Still need help': 'まだ助けが必要です？',
  'Thanks for your feedback': 'ご意見・ご感想をお聞かせください！',
  'FAQ Content': 'FAQの内容',
  'Was this article helpful': 'この記事は役に立ちましたか？',
  No: 'いいえ',
  Yes: 'はい',
  '{min} out of {total} found this helpful':
    '{total} 人中 {min} 人がこの記事が役に立ったと回答しています。',
  'No data': 'データなし',
  'Please fill out the form with as many details as possible':
    '可能なかぎり詳しい情報をご記入ください。',
  'feedback type': 'フィードバックの種類',
  'Select your feedback type': 'フィードバックの種類を選択',
  'Select your {value}': 'あなたの{value}を選ぶ',
  'Cannot be blank': '空欄にできません',
  'Character limit exceeded': '最大文字数を超えています',
  'Please enter a valid email': '有効なメールアドレスを入力してください',
  success: '成功',
  fail: '失敗',
  complete: '完了',
  error: 'エラー',
  close: '閉じる',
  leave: '離れる',
  stay: '留まる',
  cancel: 'キャンセル',
  'You will not be able to receive a reply after it is closed':
    '問題がクローズされると、回答を受け取れません。',
  'Image uploading failed': '画像アップロードが失敗しました',
  'Image reviewing failed': 'アップロードに失敗しました，画像が関連しており、不適切でないことを確認してください。',
  'You can only upload a maximum of {limit} images':
    '画像は最大「{limit}」枚までしかアップロードできません。',
  'Please check if the image format is .JPG or .PNG':
    '画像はJPGまたはPNG形式にしてください。',
  'File uploading failed': 'ファイルアップロードが失敗しました',
  'File reviewing failed': 'アップロードに失敗しました，ファイルが関連しており、不適切でないことを確認してください。',
  'You can only upload a maximum of {limit} files':
    'ファイルは最大「{limit}」枚までしかアップロードできません。',
  'Please check the file format': 'ファイル形式をご確認ください。',
  Note: 'ご注意',
  'Do you want to submit the current feedback':
    'このフィードバックを送りますか？',
  'A customer service representative will reply within {hour} hours':
    'カスタマーサービス担当者が {hour} 時間以内に返信します。',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'このフィードバックはクローズされます。総合評価をしてください。',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'タイムアウトのためフィードバックが終了しました。ご質問がある場合、新たにフィードバックをお送りください。',
  'Do you want to close the current feedback':
    'このフィードバックをクローズしますか？',
  'Rate Service': 'サービス評価',
  'Are you satisfied with our service':
    '当社のサービスにご満足いただけましたか？',
  'Thank you for your feedback! We will continue to improve our service':
    'ご意見をお寄せいただきありがとうございました。今後もサービスの向上に努めてまいります。',
  'You already rated this customer service less than {hour} hours ago':
    '{hour}時間前に、このカスタマーサービスを評価済みです。',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'ご意見をお寄せいただきありがとうございました。今後も問題解決のお手伝いをいたします。',
  'Return to top': 'トップに戻る',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `システムエラー (T_T) 。
{AppName} App のヘルプセンターから、フィードバックページを再度開いてください。`,
  'System error. Sign expired.': 'システムエラー。サインが切れました。',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 波兰语
const POLISH = {
  solved: 'Rozwiązany',
  unsolved: 'Nie rozwiązany',
  helpful: 'Pomocny',
  'not helpful': 'Nieprzydatny',
  'tip question1': 'Witaj, użytkowniku',
  'tip question2': 'Z czym potrzebujesz pomocy?',
  'new feedback': 'Nowa opinia',
  more: 'Więcej',
  feedback: 'Opinia',
  'feedback tip': 'Wypełnij formularz, podając jak najwięcej szczegółów.',
  'question type': 'Typ pytania',
  'email address': 'Adres e-mail',
  description: 'Opis',
  images: 'Obrazy',
  submit: 'Zatwierdź',
  'feedback history': 'Historia opinii',
  'feedback id': 'Identyfikator opinii',
  'rate our service': 'Oceń naszą usługę',
  Rated: 'Oceniono',
  'Reasons for dissatisfaction': 'Powody niezadowolenia',
  'Please input your feedback': 'Wpisz swoją opinię',
  processing: 'Przetwarzanie',
  'wait for your reply': 'Czekamy na Twoją odpowiedź',
  'leave some comments on our service':
    'Zostaw kilka komentarzy odnośnie naszej usługi',
  collapse: 'Pakuj się',
  'service detail': 'Szczegóły usługi',
  notification: 'Powiadomienie',
  'submit modal tip':
    'Dziękujemy za Twoją opinię. Skontaktujemy się z Tobą tak szybko, jak to możliwe.',
  confirm: 'Potwierdź',
  'satisfaction modal tip':
    'Twoja satysfakcja jest dla nas największą motywacją. Oceń nas w sklepie!',
  'thank rate':
    'Dziękujemy za ocenę! Postaramy się zapewnić Ci lepszą obsługę. ',
  'tip close':
    'Nie będziesz już w stanie otrzymać odpowiedzi w tej sprawie po jej zamknięciu.',
  back: 'Z powrotem',
  send: 'Wyślij',
  'select faq type': 'Wybierz typ problemu',
  'network error': 'Twoja sieć jest niestabilna. Spróbuj ponownie później.',
  hello: 'Cześć,',
  'What can we do to help': 'Co możemy zrobić, aby Ci pomóc?',
  Search: 'Szukaj',
  'Contact Us': 'Skontaktuj się z nami',
  'Nothing more to load': 'Nie ma nic więcej do załadowania.',
  'Search Result': 'Wynik wyszukiwania',
  'Found {value} results': 'Znaleziono {value} wyników',
  'No results for': 'Brak wyników dla',
  'Related results': 'Powiązane wyniki',
  'Still need help': 'Nadal potrzebujesz pomocy?',
  'Thanks for your feedback': 'Dziękujemy za opinię!',
  'FAQ Content': 'FAQ: treści',
  'Was this article helpful': 'Czy ten artykuł okazał się pomocny?',
  No: 'Nie',
  Yes: 'Tak',
  '{min} out of {total} found this helpful':
    '{min} z {total} uznało to za przydatne.',
  'No data': 'Brak danych.',
  'Please fill out the form with as many details as possible':
    'Wypełnij formularz, podając jak najwięcej szczegółów.',
  'feedback type': 'Typ opinii',
  'Select your feedback type': 'Wybierz typ opinii',
  'Select your {value}': 'Wybierz {value}',
  'Cannot be blank': 'To pole nie może być puste.',
  'Character limit exceeded': 'Przekroczono limit znaków.',
  'Please enter a valid email': 'Wprowadź prawidłowy adres e-mail',
  success: 'Sukces',
  fail: 'Błąd',
  complete: 'Ukończ',
  error: 'Błąd',
  close: 'Zamknij',
  leave: 'Wyjdź',
  stay: 'Zostań',
  cancel: 'Anuluj',
  'You will not be able to receive a reply after it is closed':
    'Po zamknięciu nie będziesz w stanie otrzymać odpowiedzi.',
  'Image uploading failed': 'Przesyłanie obrazu nie powiodło się.',
  'Image reviewing failed': 'Przesyłanie nie powiodło się. Upewnij się, że obraz jest odpowiedni i na temat.',
  'You can only upload a maximum of {limit} images':
    'Możesz przesłać maksymalnie {limit} obrazów.',
  'Please check if the image format is .JPG or .PNG':
    'Sprawdź, czy format obrazu to .JPG czy .PNG.',
  'File uploading failed': 'Przesyłanie pliku nie powiodło się.',
  'File reviewing failed': 'Przesyłanie nie powiodło się. Upewnij się, że plik jest odpowiedni i na temat.',
  'You can only upload a maximum of {limit} files':
    'Możesz przesłać maksymalnie {limit} plików.',
  'Please check the file format': 'Sprawdź format pliku.',
  Note: 'Uwaga',
  'Do you want to submit the current feedback':
    'Czy chcesz przesłać aktualną opinię?',
  'A customer service representative will reply within {hour} hours':
    'Przedstawiciel działu obsługi klienta odpowie w ciągu {hour} godz.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Ta opinia zostanie zamknięta. Dokonaj kompleksowej oceny.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Twoja opinia wygasła z powodu przekroczenia limitu czasu. Jeśli masz jakieś pytania, utwórz nową opinię. Dziękujemy!',
  'Do you want to close the current feedback':
    'Czy chcesz zamknąć bieżącą opinię?',
  'Rate Service': 'Oceń usługę',
  'Are you satisfied with our service': 'Czy podoba Ci się nasza usługa?',
  'Thank you for your feedback! We will continue to improve our service':
    'Dziękujemy za Twoją opinię! Będziemy nadal ulepszać naszą usługę.',
  'You already rated this customer service less than {hour} hours ago':
    'Ta obsługa klienta została już przez Ciebie oceniona mniej niż {hour} godz. temu.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Dziękujemy za Twoją opinię! Postaramy się pomóc Ci rozwiązać ten problem.',
  'Return to top': 'Wróć do góry',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Błąd systemu (T_T)
Otwórz ponownie „Opinie”, przechodząc do aplikacji {AppName} → Centrum pomocy.`,
  'System error. Sign expired.': 'Błąd systemu. Znak wygasł.',
  'Network Status': 'Stan sieci',
  Testing: 'Testowanie',
  'Please allow us to access your network status information to help solve the issue.':
    'Aby uzyskać pomoc w rozwiązaniu problemu, prosimy o umożliwienie nam dostępu do informacji o stanie sieci.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Trwa testowanie sieci. Może to potrwać 10-30 sekund.',
  'Done! Thank you!': 'Gotowe! Dziękujemy!',
  OK: 'OK'
}

// 土耳其语
const Turkish = {
  solved: 'Çözüldü',
  unsolved: 'Çözümlenmemiş',
  helpful: 'Yardımcı oldu',
  'not helpful': 'Yardımcı olmadı',
  'tip question1': 'Merhaba, kullanıcı',
  'tip question2': 'Ne konuda yardıma ihtiyacın var?',
  'new feedback': 'Yeni geri bildirim',
  more: 'Daha fazlası',
  feedback: 'Geri bildirim',
  'feedback tip': 'Lütfen formu mümkün olduğunca fazla ayrıntıyla doldur.',
  'question type': 'Soru tipi',
  'email address': 'E-posta adresi',
  description: 'Açıklama',
  images: 'Görüntüler',
  submit: 'Gönder',
  'feedback history': 'Geri bildirim geçmişi',
  'feedback id': 'Geri bildirim kimliği',
  'rate our service': 'Hizmetlerimizi değerlendir',
  Rated: 'Değerlendirildi',
  'Reasons for dissatisfaction': 'Memnuniyetsizlik nedenleri',
  'Please input your feedback': 'Lütfen geri bildirimini gir',
  processing: 'İşleniyor',
  'wait for your reply': 'Cevabını bekliyorum',
  'leave some comments on our service':
    'Hizmetlerimiz hakkında bir yorum bırak',
  collapse: 'Çökme',
  'service detail': 'Hizmet detayı',
  notification: 'Bildirim',
  'submit modal tip':
    'Geri bildirimin için teşekkür ederiz ve en kısa sürede geri dönüş sağlayacağız.',
  confirm: 'Onayla',
  'satisfaction modal tip': `Memnuniyetin bizim için en büyük destek olacaktır. 
  Mağazada bize puan ver!`,
  'thank rate': 'Puanlama için teşekkür ederiz! Hizmetlerimizi geliştireceğiz.',
  'tip close': 'Kapatıldıktan sonra bu sorun için artık yanıt alamayacaksın.',
  back: 'Geri',
  send: 'Gönder',
  'select faq type': 'Bir sorun türü seç',
  'network error': 'Ağ bağlantın stabil değil. Lütfen daha sonra tekrar dene.',

  hello: 'Merhaba,',
  'What can we do to help': 'Yardım etmek için ne yapabiliriz?',
  Search: 'Ara',
  'Contact Us': 'Bizimle iletişime geç',
  'Nothing more to load': 'Yüklenecek başka bir şey yok.',
  'Search Result': 'Arama sonuçları',
  'Found {value} results': '{value} sonuç bulundu',
  'No results for': 'Şunun için sonuç bulunamadı',
  'Related results': 'İlgili sonuçlar',
  'Still need help': 'Hala yardıma ihtiyacın var mı?',
  'Thanks for your feedback': 'Geri bildirimin için teşekkürler!',
  'FAQ Content': 'SSS İçeriği',
  'Was this article helpful': 'Bu makale yardımcı oldu mu?',
  No: 'Hayır',
  Yes: 'Evet',
  '{min} out of {total} found this helpful':
    '{total} kişiden {min} tanesi bunu faydalı buldu.',
  'No data': 'Veri yok.',
  'Please fill out the form with as many details as possible':
    'Lütfen formu mümkün olduğunca fazla ayrıntıyla doldur.',
  'feedback type': 'Geri bildirim türü',
  'Select your feedback type': 'Geri bildirim türünü seç',
  'Select your {value}': '{value} seç',
  'Cannot be blank': 'Boş bırakılamaz.',
  'Character limit exceeded': 'Karakter sınırı aşıldı.',
  'Please enter a valid email': 'lütfen geçerli eposta adresini giriniz',
  success: 'Başarılı',
  fail: 'Hata',
  complete: 'Tamamla',
  error: 'Hata',
  close: 'Kapat',
  leave: 'Çık',
  stay: 'Kal',
  cancel: 'İptal',
  'You will not be able to receive a reply after it is closed':
    'Kapatıldıktan sonra cevap alamayacaksın.',
  'Image uploading failed': 'Görsel yüklenemedi.',
  'Image reviewing failed': 'Yükleme başarısız. Görselin ilgili ve uygun olduğundan emin olun.',
  'You can only upload a maximum of {limit} images':
    'Yalnızca maksimum {limit} adet resim yükleyebilirsin.',
  'Please check if the image format is .JPG or .PNG':
    'Lütfen görüntü formatının .JPG veya .PNG olup olmadığını kontrol et.',
  'File uploading failed': 'Dosya yüklenemedi.',
  'File reviewing failed': 'Yükleme başarısız. Dosyanın ilgili ve uygun olduğundan emin olun.',
  'You can only upload a maximum of {limit} files':
    'Yalnızca maksimum {limit} adet dosya yükleyebilirsin.',
  'Please check the file format': 'Lütfen dosya biçimini kontrol edina.',
  Note: 'Hatırlatma',
  'Do you want to submit the current feedback':
    'Mevcut geri bildirimi göndermek istiyor musun?',
  'A customer service representative will reply within {hour} hours':
    'Bir müşteri hizmetleri temsilcisi {hour} saat içinde yanıt verecektir.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Bu geri bildirim kapatılacak. Lütfen kapsamlı bir değerlendirme yap.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Geri bildirimin, zaman sınırını aştığın için sona erdi. Herhangi bir sorun varsa, lütfen yeni geri bildirim oluştur. Teşekkürler!',
  'Do you want to close the current feedback':
    'Mevcut geri bildirimi kapatmak istiyor musun?',
  'Rate Service': 'Hizmetleri değerlendir',
  'Are you satisfied with our service': 'Hizmetlerimizden memnun musun?',
  'Thank you for your feedback! We will continue to improve our service':
    'Geri bildirimin için teşekkür ederiz! Hizmetlerimizi geliştirmeye devam edeceğiz.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Geri bildirimin için teşekkür ederiz! Sorunu çözmeye yardımcı olmaya devam edeceğiz.',
  'You already rated this customer service less than {hour} hours ago':
    'Bu müşteri hizmetini {hour} saatten daha kısa bir süre önce zaten değerlendirmiştin.',
  'Return to top': 'Başa dön',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Sistem hatası (T_T)
Lütfen {AppName} Uygulaması → Yardım Merkezi'ne giderek Geri Bildirim sayfasını yeniden açın.`,
  'System error. Sign expired.': 'Sistem hatası. İşaretin süresi doldu.',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 荷兰语
const Dutch = {
  solved: 'Opgelost',
  unsolved: 'Onopgelost',
  helpful: 'Nuttig',
  'not helpful': 'Niet nuttig',
  'new feedback': 'Nieuwe feedback',
  more: 'Meer',
  feedback: 'Feedback',
  'feedback tip': 'Vul het formulier in met zoveel mogelijk details.',
  'question type': 'Vraag type',
  'email address': 'E-mailadres',
  description: 'Omschrijving',
  images: 'Afbeeldingen',
  submit: 'Indienen',
  'feedback history': 'Feedback geschiedenis',
  'feedback id': 'Feedback ID',
  'rate our service': 'Beoordeel onze service',
  Rated: 'Beoordeeld',
  'Reasons for dissatisfaction': 'Redenen voor ontevredenheid',
  'Please input your feedback': 'Voer je feedback in',
  processing: 'Wordt verwerkt',
  'wait for your reply': 'Wachten op uw antwoord',
  'leave some comments on our service':
    'Laat een opmerking achter over onze service',
  collapse: 'Uitvouwen',
  'service detail': 'Service details',
  notification: 'Melding',
  'submit modal tip':
    'Bedankt voor je feedback, we zullen zo spoedig mogelijk bij je terugkomen.',
  confirm: 'Bevestigen',
  'satisfaction modal tip': `Jouw tevredenheid is onze grootste aanmoediding.`,
  'thank rate':
    'Bedankt voor je beoordeling! We zullen onze service verbeteren.',
  'tip close':
    'Nadat dit probleem is gesloten, zul je er geen antwoorden meer op kunnen ontvangen.',
  back: 'Terug',
  send: 'Versturen',
  'network error':
    'Je netwerkverbinding is instabiel. Probeer het later opnieuw.',

  hello: 'Hoi,',
  'What can we do to help': 'Hoe kunnen we je helpen?',
  Search: 'Zoeken',
  'Contact Us': 'Contact',
  'Nothing more to load': 'Niets meer om te laden',
  'Search Result': 'Zoekresultaat',
  'Found {value} results': 'Gevonden {value} resultaten',
  'No results for': 'Geen resultaten gevonden voor',
  'Related results': 'Verwante resultaten',
  'Still need help': 'Nog steeds hulp nodig?',
  'Thanks for your feedback': 'Bedankt voor je feedback!',
  'FAQ Content': 'FAQ',
  'Was this article helpful': 'Was dit artikel nuttig?',
  No: 'Nee',
  Yes: 'Ja',
  '{min} out of {total} found this helpful':
    '{min} van {total} vond dit nuttig.',
  'No data': 'Geen gegevens.',
  'Please fill out the form with as many details as possible':
    'Vul het formulier in met zoveel mogelijk details.',
  'feedback type': 'Feedback type',
  'Select your feedback type': 'Selecteer je feedback type',
  'Select your {value}': 'Selecteer je {value}',
  'Cannot be blank': 'Mag niet leeg zijn.',
  'Character limit exceeded': 'Tekenlimiet overschreden.',
  'Please enter a valid email': 'Voer een geldig e-mailadres in',
  success: 'Geslaagd',
  fail: 'Mislukt',
  complete: 'Voltooien',
  error: 'Fout',
  close: 'Sluiten',
  leave: 'Verlaten',
  stay: 'Blijven',
  cancel: 'Annuleren',
  'You will not be able to receive a reply after it is closed':
    'Nadat het gesloten is, zul je geen antwoord meer kunnen ontvangen.',
  'Image uploading failed': 'Afbeelding uploaden mislukt.',
  'Image reviewing failed': 'Upload mislukt. Zorg ervoor dat je afbeelding relevant en gepast is.',
  'You can only upload a maximum of {limit} images':
    'Je kunt maximaal {limit} afbeeldingen uploaden.',
  'Please check if the image format is .JPG or .PNG':
    'Controleer of het afbeeldingstype .JPG of .PNG is.',
  'File uploading failed': 'Bestand uploaden mislukt',
  'File reviewing failed': 'Upload mislukt. Zorg ervoor dat je bestand relevant en gepast is.',
  'You can only upload a maximum of {limit} files':
    'Je kunt maximaal {limit} bestanden uploaden',
  'Please check the file format': 'Controleer het bestandsformaat',
  Note: 'Mededeling',
  'Do you want to submit the current feedback':
    'Wil je je huidige feedback indienen?',
  'A customer service representative will reply within {hour} hours':
    'Een klantenservicemedewerker zal je binnen {hour} beantwoorden.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Deze feedback zal worden gesloten. Overweeg het goed.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Je feedback is afgelopen omdat de tijdslimiet is overschreden. Indien je enige vragen hebt, maak nieuwe feedback aan. Dank je!',
  'Do you want to close the current feedback':
    'Wil je de huidige feedback sluiten?',
  'Rate Service': 'Service beoordelen',
  'Are you satisfied with our service': 'Ben je tevreden met onze service?',
  'Thank you for your feedback! We will continue to improve our service':
    'Bedankt voor je feedback! We zullen onze service blijven verbeteren.',
  'You already rated this customer service less than {hour} hours ago':
    'Je hebt deze klantenservice minder dan {hour} geleden al beoordeeld.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Bedankt voor je feedback! We zullen er alles aan doen om je probleem te verhelpen.',
  'Return to top': 'Terugkeren naar boven',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Systeemfout (T_T)
Heropen de Feedback pagina door naar {AppName} App → Hulpcentrum te gaan.`,
  'System error. Sign expired.': 'Systeemfout. Inlogpoging verlopen.',
  'Network Status': 'Netwerkstatus',
  Testing: 'Testen',
  'Please allow us to access your network status information to help solve the issue.':
    'Gelieve je netwerkstatus informatie te delen zodat we het probleem kunnen verhelpen.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Netwerk testen is bezig. Dit kan 10–30 seconden duren. Even geduld aub.',
  'Done! Thank you!': 'Klaar! Dank je!',
  OK: 'Oké'
}

// 瑞典语
const Swedish = {
  solved: 'Löst',
  unsolved: 'Olöst',
  helpful: 'Hjälpte',
  'not helpful': 'Hjälpte inte',
  'new feedback': 'Ny feedback',
  more: 'Mer',
  feedback: 'Feedback',
  'feedback tip':
    'Vänligen fyll i formuläret med så många detaljer som möjligt.',
  'question type': 'Typ av fråga',
  'email address': 'E-postadress',
  description: 'Beskrivning',
  images: 'Bilder',
  submit: 'Skicka',
  'feedback history': 'Feedbackhistorik',
  'feedback id': 'Feedback-ID',
  'rate our service': 'Betygsätt vår tjänst',
  Rated: 'Betygsatt',
  'Reasons for dissatisfaction': 'Skäl till missnöje',
  'Please input your feedback': 'Skriv din feedback',
  processing: 'Under bearbetning',
  'wait for your reply': 'Väntar på ditt svar',
  'leave some comments on our service': 'Lämna en kommentar om vår tjänst',
  collapse: 'Minimera',
  'service detail': 'Servicedetalj',
  notification: 'Notifikation',
  'submit modal tip':
    'Tack för din feedback. Vi återkommer till dig så snart som möjligt.',
  confirm: 'Bekräfta',
  'satisfaction modal tip': `Det viktigaste för oss är att du är nöjd.  Betygsätt oss i app-butiken!`,
  'thank rate': 'Tack för ditt betyg! Vi kommer att förbättra våra tjänster.',
  'tip close':
    'Du kommer inte längre att kunna få svar på detta ärende efter att det har avslutats.',
  back: 'Tillbaka',
  send: 'Skicka',
  'network error':
    'Din nätverksanslutning är instabil. Vänligen försök igen senare.',

  hello: 'Hej,',
  'What can we do to help': 'Vad kan vi göra för att hjälpa till?',
  Search: 'Sök',
  'Contact Us': 'Kontakta oss',
  'Nothing more to load': 'Inget mer att ladda.',
  'Search Result': 'Sökresultat',
  'Found {value} results': 'Hittade {value} resultat',
  'No results for': 'Inga resultat hittades för',
  'Related results': 'Relaterade resultat',
  'Still need help': 'Behöver du fortfarande hjälp?',
  'Thanks for your feedback': 'Tack för din feedback!',
  'FAQ Content': 'FAQ',
  'Was this article helpful': 'Fick du hjälp av denna artikel?',
  No: 'Nej',
  Yes: 'Ja',
  '{min} out of {total} found this helpful':
    '{min} av {total} tyckte att detta hjälpte.',
  'No data': 'Ingen information.',
  'Please fill out the form with as many details as possible':
    'Vänligen fyll i formuläret med så många detaljer som möjligt.',
  'feedback type': 'Typ av feedback',
  'Select your feedback type': 'Välj din typ av feedback',
  'Select your {value}': 'Välj din {value}',
  'Cannot be blank': 'Får inte vara tom.',
  'Character limit exceeded': 'Teckengränsen har överskridits.',
  'Please enter a valid email': 'Ange en giltig e-postadress',
  success: 'Lyckades',
  fail: 'Misslyckades',
  complete: 'Klar',
  error: 'Fel',
  close: 'Stäng',
  leave: 'Lämna',
  stay: 'Stanna kvar',
  cancel: 'Avbryt',
  'You will not be able to receive a reply after it is closed':
    'Du kommer inte att kunna få svar efter att det är avslutat.',
  'Image uploading failed': 'Det gick inte att ladda upp bilden.',
  'Image reviewing failed': 'Uppladdningen misslyckades. Se till att bilden är relevant och lämplig.',
  'You can only upload a maximum of {limit} images':
    'Du kan högst ladda upp {limit} bilder.',
  'Please check if the image format is .JPG or .PNG':
    'Kontrollera om bildformatet är .JPG eller .PNG.',
  'File uploading failed': 'Uppladdningen misslyckades',
  'File reviewing failed': 'Uppladdningen misslyckades. Se till att filen är relevant och lämplig.',
  'You can only upload a maximum of {limit} files':
    'Du kan bara ladda upp högst {limit} filer',
  'Please check the file format': 'Kontrollera filformatet',
  Note: 'Obs',
  'Do you want to submit the current feedback':
    'Vill du skicka in denna feedback?',
  'A customer service representative will reply within {hour} hours':
    'En kundtjänstmedarbetare kommer att svara inom {hour} timmar.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Denna feedback kommer att stängas. Ge en utvärdering om hela ärendet.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Din feedback har avbrutits eftersom det gått för lång tid. Om du har några frågor kan du skapa en ny feedback. Tack!',
  'Do you want to close the current feedback':
    'Vill du stänga den aktuella feedbacken?',
  'Rate Service': 'Betygsätt tjänsten',
  'Are you satisfied with our service': 'Är du nöjd med vår tjänst?',

  'Thank you for your feedback! We will continue to improve our service':
    'Tack för din feedback! Vi kommer att fortsätta att förbättra våra tjänster.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Tack för din feedback! Vi kommer att fortsätta att hjälpa dig att lösa problemet.',
  'You already rated this customer service less than {hour} hours ago':
    'Du har redan betygsatt vår kundtjänst för mindre än {hour} timmar sedan.',
  'Return to top': 'Till toppen av sidan',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Systemfel (T_T)
Öppna Feedbacksidan igen genom att gå till {AppName} App → Hjälpcenter.`,
  'System error. Sign expired.': '',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 丹麦语
const Danish = {
  solved: 'Løst',
  unsolved: 'Uopklaret',
  helpful: 'Nyttig',
  'not helpful': 'Ikke nyttig',
  'new feedback': 'Ny feedback',
  more: 'Mere',
  feedback: 'Feedback',
  'feedback tip':
    'Udfyld venligst formularen med så mange oplysninger som muligt.',
  'question type': 'Spørgsmålstype',
  'email address': 'E-mailadresse',
  description: 'Beskrivelse',
  images: 'Billeder',
  submit: 'Indsend',
  'feedback history': 'Feedback-historik',
  'feedback id': 'Feedback-ID',
  'rate our service': 'Bedøm vores tjeneste',
  Rated: 'Bedømt',
  'Reasons for dissatisfaction': 'Årsager til utilfredshed',
  'Please input your feedback': 'Indtast din feedback',
  processing: 'Behandler',
  'wait for your reply': 'vent på svaret ditt',
  'leave some comments on our service':
    'Efterlad en kommentar til vores tjeneste',
  collapse: 'Kollaps',
  'service detail': 'Detaljer om tjeneste',
  notification: 'Meddelelse',
  'submit modal tip':
    'Tak for din feedback, og vi vender tilbage til dig så hurtigt som muligt.',
  confirm: 'Bekræft',

  'satisfaction modal tip': `Det er vigtigt for os, at du er tilfreds.  Bedøm os i butikken!`,
  'thank rate': 'Tak for din bedømmelse! Vi vil forbedre vores tjeneste.',
  'tip close':
    'Du vil ikke længere kunne modtage et svar på dette spørgsmål, efter at det er blevet lukket.',
  back: 'Tilbage',
  send: 'Send',
  'network error':
    'Din netværksforbindelse er ustabil. Prøv venligst igen senere.',

  hello: 'Hej,',
  'What can we do to help': 'Hvad kan vi gøre for at hjælpe?',
  Search: 'Søg på',
  'Contact Us': 'Kontakt os',
  'Nothing more to load': 'Der er ikke mere at indlæse.',
  'Search Result': 'Søgeresultat',
  'Found {value} results': 'Fundet {value} resultater',
  'No results for': 'Ingen resultater fundet for',
  'Related results': 'Relaterede resultater',
  'Still need help': 'Har du stadig brug for hjælp?',
  'Thanks for your feedback': 'Tak for din feedback!',
  'FAQ Content': 'FAQ-indhold',
  'Was this article helpful': 'Var denne artikel nyttig?',
  No: 'Nej',
  Yes: 'Ja',
  '{min} out of {total} found this helpful':
    '{min} ud af {total} fandt dette nyttigt.',
  'No data': 'Ingen data.',
  'Please fill out the form with as many details as possible':
    'Udfyld venligst formularen med så mange oplysninger som muligt.',
  'feedback type': 'Type feedback',
  'Select your feedback type': 'Vælg din type af feedback',
  'Select your {value}': 'Vælg din {value}',
  'Cannot be blank': 'Kan ikke være tom.',
  'Character limit exceeded': 'Karaktergrænsen er overskredet.',
  'Please enter a valid email': 'Indtast venligst en gyldig e-mail',
  success: 'Lykkedes',
  fail: 'Mislykket',
  complete: 'Udfyld',
  error: 'Fejl',
  close: 'Luk',
  leave: 'Forlad',
  stay: 'Bliv',
  cancel: 'Annuller',
  'You will not be able to receive a reply after it is closed':
    'Du vil ikke kunne modtage et svar, efter at den er lukket.',
  'Image uploading failed': 'Upload af billede mislykkedes.',
  'Image reviewing failed': 'Upload mislykkedes. Sørg for, at billedet er relevant og passende.',
  'You can only upload a maximum of {limit} images':
    'Du kan kun uploade et maksimum af {limit} billeder.',
  'Please check if the image format is .JPG or .PNG':
    'Kontroller venligst, om billedformatet er .JPG eller .PNG.',
  'File uploading failed': 'Filoverførsel mislykkedes',
  'File reviewing failed': 'Filoverførsel mislykkedes. Sørg for, at filen er relevant og passende.',
  'You can only upload a maximum of {limit} files':
    'Du kan kun uploade et maksimum af {limit} filer',
  'Please check the file format': 'Kontroller venligst filformatet',
  Note: 'Meddelelse',
  'Do you want to submit the current feedback':
    'Ønsker du at indsende den aktuelle feedback?',
  'A customer service representative will reply within {hour} hours':
    'En kundeservicemedarbejder vil svare inden for {hour} timer.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Denne feedback vil blive lukket. Lav venligst en omfattende evaluering.',

  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Din feedback er afsluttet for overskridelse af tidsgrænsen. Hvis du har spørgsmål, bedes du oprette en ny feedback. Tak!',
  'Do you want to close the current feedback':
    'Ønsker du at lukke den nuværende feedback?',
  'Rate Service': 'Vurder tjeneste',
  'Are you satisfied with our service': 'Er du tilfreds med vores tjeneste?',

  'Thank you for your feedback! We will continue to improve our service':
    'Tak for din feedback! Vi vil fortsætte med at forbedre vores tjeneste.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Tak for din feedback! Vi vil fortsat hjælpe dig med at løse problemet.',
  'You already rated this customer service less than {hour} hours ago':
    'Du har allerede bedømt denne kundeservice for mindre end {time} timer siden.',
  'Return to top': 'Tilbage til toppen',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Systemfejl (T_T)
Åbn venligst feedback-siden igen ved at gå til {AppName} App → Hjælpecenter.`,
  'System error. Sign expired.': 'For mange ændringer',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 挪威语
const Norwegian = {
  solved: 'Løst',
  unsolved: 'Uløst',
  helpful: 'Nyttig',
  'not helpful': 'Ikke nyttig',
  'new feedback': 'Ny tilbakemelding',
  more: 'Mer',
  feedback: 'Tilbakemelding',
  'feedback tip': 'Vennligst fyll ut skjema med så mange detaljer som mulig.',
  'question type': 'Spørsmålstype',
  'email address': 'E-postadresse',
  description: 'Beskrivelse',
  images: 'Bilder',
  submit: 'Send inn',
  'feedback history': 'Tilbakemelding historikk',
  'feedback id': 'Tilbakemelding ID',
  'rate our service': 'Ranger vår service',
  Rated: 'Vurdert',
  'Reasons for dissatisfaction': 'Årsaker til misnøye',
  'Please input your feedback': 'Skriv inn tilbakemeldingen din',
  processing: 'Under behandling',
  'wait for your reply': 'Waiting for your reply',
  'leave some comments on our service': 'Skriv en kommentar om vår service',
  collapse: 'Minimer',
  'service detail': 'Servicedetalj',
  notification: 'Varsel',
  'submit modal tip':
    'Takk for din tilbakemelding. Vi vil komme tilbake til deg så raskt som mulig.',
  confirm: 'Bekreft',

  'satisfaction modal tip': `Det er viktig for oss at du er fornøyd. Ranger oss i appbutikken!`,
  'thank rate': 'Takk for din rangering! Vi vil forbedre tjenestene våre.',
  'tip close':
    'Du vil ikke lenger kunne motta et svar i forbindelse med dette spørsmålet etter at den er blitt avsluttet.',
  back: 'Tilbake',
  send: 'Send',
  'network error': 'Din nettverksforbindelse er ustabil. Prøv igjen senere.',

  hello: 'Hei,',
  'What can we do to help': 'Hva kan vi hjelpe deg med?',
  Search: 'Søk',
  'Contact Us': 'Kontakt oss',
  'Nothing more to load': 'Ikke mer å laste.',
  'Search Result': 'Søkeresultat',
  'Found {value} results': 'Funnet {value} resultater',
  'No results for': 'Ingen resultater funnet for',
  'Related results': 'Relaterte resultater',
  'Still need help': 'Trenger du fortsatt hjelp?',
  'Thanks for your feedback': 'Takk for din tilbakemelding!',
  'FAQ Content': 'FAQ',
  'Was this article helpful': 'Var denne artikkelen nyttig?',
  No: 'Nei',
  Yes: 'Ja',
  '{min} out of {total} found this helpful':
    '{min} av {total} synes denne var nyttig.',
  'No data': 'Ingen data.',
  'Please fill out the form with as many details as possible':
    'Vennligst fyll ut skjema med så mange detaljer som mulig.',
  'feedback type': 'Tilbakemeldingstype',
  'Select your feedback type': 'Velg type tilbakemelding',
  'Select your {value}': 'Velg din {value}',
  'Cannot be blank': 'Kan ikke være tom.',
  'Character limit exceeded': 'Karaktergrense overskredet.',
  'Please enter a valid email': 'Skriv inn en gyldig e-postadresse',
  success: 'Suksess',
  fail: 'Feilet',
  complete: 'Fullført',
  error: 'Feil',
  close: 'Lukk',
  leave: 'Forlat',
  stay: 'Bli',
  cancel: 'Avbryt',
  'You will not be able to receive a reply after it is closed':
    'Du vil ikke kunne motta svar etter at den er avsluttet.',
  'Image uploading failed': 'Feil ved bildeopplasting.',
  'Image reviewing failed': 'Opplasting mislyktes. Sørg for at bildet er relevant og passende.',
  'You can only upload a maximum of {limit} images':
    'Du kan kun laste opp maksimalt {limit} bilder.',
  'Please check if the image format is .JPG or .PNG':
    'Sjekk at bildeformat er .JPG eller .PNG.',
  'File uploading failed': 'Filopplasting feilet',
  'File reviewing failed': 'Filopplasting feilet. Sørg for at filen er relevant og passende.',
  'You can only upload a maximum of {limit} files':
    'Du kan maksimalt laste opp {limit} filer',
  'Please check the file format': 'Kontroller filmformat',
  Note: 'Notat',
  'Do you want to submit the current feedback':
    'Vil du sende inn denne tilbakemeldingen?',
  'A customer service representative will reply within {hour} hours':
    'En kundeservicerepresentant vil svare deg innen {hour} timer.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Denne tilbakemeldingen vil bli lukket. Vennligst lag en omfattende evaluering.',

  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Din tilbakemelding er avsluttet for å ha overskredet tidsgrensen. Dersom du har spørsmål, opprett en ny tilbakemelding. Takk!',
  'Do you want to close the current feedback':
    'Vil du lukke den aktuelle tilbakemeldingen?',
  'Rate Service': 'Ranger servicen',
  'Are you satisfied with our service': 'Er du fornøyd med servicen?',

  'Thank you for your feedback! We will continue to improve our service':
    'Takk for din tilbakemelding! Vi vil fortsette å forbedre våre tjenester.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Takk for din tilbakemelding! Vi vil fortsette å hjelpe deg med å løse problemet.',
  'You already rated this customer service less than {hour} hours ago':
    'Du har allerede rangert denne kundeservicen for mindre enn {hour} timer siden.',
  'Return to top': 'Tilbake til toppen',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Systemfeil (T_T)
Vennligst åpne opp Tilbakemelding-siden ved å gå til {AppName} App → Hjelpesenter.`,
  'System error. Sign expired.': 'For mange endringer',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 芬兰语
const Finnish = {
  solved: 'Ratkaistu',
  unsolved: 'Ratkaisematon',
  helpful: 'Hyödyllistä',
  'not helpful': 'Ei hyödyllistä',
  'new feedback': 'Uusi palaute',
  more: 'Enemmän',
  feedback: 'Feedback',
  'feedback tip': 'Täytä lomake mahdollisimman täydellisesti.',
  'question type': 'Kysymyksen tyyppi',
  'email address': 'Sähköpostiosoite',
  description: 'Kuvaus',
  images: 'Kuvat',
  submit: 'Lähetä',
  'feedback history': 'Palautehistoria',
  'feedback id': 'Palautteen tunnus',
  'rate our service': 'Arvioi palvelumme',
  Rated: 'Arvioitu',
  'Reasons for dissatisfaction': 'Tyytymättömyyden syyt',
  'Please input your feedback': 'Kirjoita palautteesi',
  processing: 'Käsittelyssä',
  'wait for your reply': 'Vastaustanne odottaen',
  'leave some comments on our service': 'Jätä kommentti palvelustamme',
  collapse: 'Piilota',
  'service detail': 'Palvelun yksityiskohdat',
  notification: 'Ilmoitus',
  'submit modal tip':
    'Kiitos palautteestasi. Palaamme asiaan mahdollisimman pian.',
  confirm: 'Vahvista',

  'satisfaction modal tip': `Tyytyväisyytesi on meille ensiarvoisen tärkeää. 
  Arvioi meidät kaupassa!`,
  'thank rate': 'Kiitos arviostasi! Parannamme palveluitamme.',
  'tip close':
    'Et voi enää saada vastausta tähän palautteeseen asian sulkemisen jälkeen.',
  back: 'Takaisin',
  send: 'Lähetä',
  'network error': 'Verkkoyhteytesi on epävakaa. Yritä uudelleen myöhemmin.',

  hello: 'Hei!',
  'What can we do to help': 'Miten voimme auttaa?',
  Search: 'Hae',
  'Contact Us': 'Ota yhteyttä',
  'Nothing more to load': 'Ei lisää ladattavaa.',
  'Search Result': 'Hakutulos',
  'Found {value} results': 'Löytyi {value} hakutulosta',
  'No results for': 'Ei tuloksia haulle',
  'Related results': 'Liittyvät hakutulokset',
  'Still need help': 'Tarvitsetko vielä apua?',
  'Thanks for your feedback': 'Kiitos palautteestasi!',
  'FAQ Content': 'UKK Sisältö',
  'Was this article helpful': 'Oliko tästä artikkelista apua?',
  No: 'Ei',
  Yes: 'Kyllä',
  '{min} out of {total} found this helpful':
    '{min}/{total} piti tätä hyödyllisenä.',
  'No data': 'Ei dataa.',
  'Please fill out the form with as many details as possible':
    'Täytä lomake mahdollisimman täydellisesti.',
  'feedback type': 'Palautteen tyyppi',
  'Select your feedback type': 'Valitse palautteen tyyppi',
  'Select your {value}': 'Valitse {value}',
  'Cannot be blank': 'Ei voi olla tyhjä.',
  'Character limit exceeded': 'Merkkimäärä ylitetty.',
  'Please enter a valid email': 'Syötä oikea sähköpostiosoite',
  success: 'Onnistui',
  fail: 'Epäonnistui',
  complete: 'Valmis',
  error: 'Virhe',
  close: 'Sulje',
  leave: 'Poistu',
  stay: 'Pysy',
  cancel: 'Peruuta',
  'You will not be able to receive a reply after it is closed':
    'Et voi saada vastausta asian sulkemisen jälkeen.',
  'Image uploading failed': 'Kuvan lataus epäonnistui.',
  'Image reviewing failed': 'Lataus epäonnistui. Varmista, että kuva on aiheeseen liittyvä ja sopiva.',
  'You can only upload a maximum of {limit} images':
    'Voit ladata enintään {limit} kuvaa.',
  'Please check if the image format is .JPG or .PNG':
    'Tarkista, onko kuvan muoto .JPG tai .PNG.',
  'File uploading failed': 'Tiedoston lataaminen epäonnistui',
  'File reviewing failed': 'Lataus epäonnistui. Varmista, että tiedosto on aiheeseen liittyvä ja sopiva.',
  'You can only upload a maximum of {limit} files':
    'Voi ladata korkeintaan {limit} tiedostoa',
  'Please check the file format': 'Tarkista tiedostomuoto',
  Note: 'Ilmoitus',
  'Do you want to submit the current feedback':
    'Haluatko lähettää nykyisen palautteen?',
  'A customer service representative will reply within {hour} hours':
    'Asiakaspalvelun edustaja vastaa {hour} tunnin kuluessa.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Tämä palaute suljetaan. Ole hyvä ja anna kokonaisarvio.',

  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Palautteesi lähettäminen keskeytyi aikarajan ylittymisen vuoksi. Jos sinulla on kysyttävää, luo uusi palaute. Kiitos.',
  'Do you want to close the current feedback':
    'Haluatko sulkea nykyisen palautelomakkeen?',
  'Rate Service': 'Arvostele palvelu',
  'Are you satisfied with our service': 'Oletko tyytyväinen palveluumme?',

  'Thank you for your feedback! We will continue to improve our service':
    'Kiitos palautteesta! Jatkamme palveluidemme kehittämistä.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Kiitos palautteesta! Autamme sinua edelleen ratkaisemaan ongelman.',
  'You already rated this customer service less than {hour} hours ago':
    'Arvioit jo tämän asiakaspalvelun alle {hour} tuntia sitten.',
  'Return to top': 'Palaa alkuun',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Järjestelmävirhe (T_T)
Avaa palautesivu uudelleen menemällä sovellukseen {AppName} → Tukikeskus`,
  'System error. Sign expired.': 'Liikaa muutoksia',
  'Network Status': 'Network Status',
  Testing: 'Testing',
  'Please allow us to access your network status information to help solve the issue.':
    'Please allow us to access your network status information to help solve the issue.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Network testing is in progress. It may take 10–30 seconds. Please wait.',
  'Done! Thank you!': 'Done! Thank you!',
  OK: 'OK'
}

// 印尼语
const Indonesian = {
  solved: 'Selesai',
  unsolved: 'Belum selesai',
  helpful: 'Membantu',
  'not helpful': 'Tidak membantu',
  'new feedback': 'Umpan balik baru',
  'tip question1': 'Halo,',
  'tip question2': 'Apa yang Anda perlukan untuk mendapatkan bantuan?',
  more: 'Lebih',
  feedback: 'Umpan Balik',
  'feedback tip': 'Silakan isi formulir dengan sedetail mungkin',
  'question type': 'Tipe pertanyaan',
  'email address': 'Alamat email',
  description: 'Keterangan',
  images: 'Gambar',
  submit: 'Kirim',
  'feedback history': 'Riwayat umpan balik',
  'feedback id': 'ID Umpan Balik',
  'rate our service': 'Nilai layanan kami',
  Rated: 'Dinilai',
  'Reasons for dissatisfaction': 'Alasan ketidakpuasan',
  'Please input your feedback': 'Tulis masukan Anda',
  processing: 'Diproses',
  'wait for your reply': 'tunggu balasan Anda',
  'leave some comments on our service':
    'Tinggalkan komentar tentang layanan kami',
  collapse: 'Perkecil',
  'service detail': 'Detail layanan',
  notification: 'Notifikasi',
  'submit modal tip':
    'Terima kasih atas umpan balikmu dan kami akan menghubungimu secepat mungkin.',
  confirm: 'Mengonfirmasi',
  'satisfaction modal tip': `Kepuasanmu adalah dorongan terbesar bagi kami.
  Nilai kami di store!`,
  'thank rate':
    'Terima kasih atas penilaianmu! Kami akan meningkatkan layanan kami.',
  'tip close':
    'Kamu tidak akan lagi dapat menerima balasan untuk masalah ini setelah masalah ini ditutup.',
  back: 'Kembali',
  send: 'Kirim',
  'select faq type': 'pilih jenis faq',
  'network error': 'Koneksi jaringanmu tidak stabil. Coba lagi nanti.',

  hello: 'Halo',
  'What can we do to help': 'apa yang bisa kami bantu?',
  Search: 'Cari',
  'Contact Us': 'Hubungi Kami',
  'Nothing more to load': 'Tidak ada lagi yang harus dimuat.',
  'Search Result': 'Hasil Pencarian',
  'Found {value} results': 'Menemukan {value} hasil',
  'No results for': 'Tidak ada hasil yang ditemukan untuk',
  'Related results': 'Hasil terkait',
  'Still need help': 'Masih butuh bantuan?',
  'Thanks for your feedback': 'Terima kasih atas umpan balikmu!',
  'FAQ Content': 'Konten FAQ',
  'Was this article helpful': 'Apakah artikel ini berguna?',
  No: 'Tidak',
  Yes: 'Ya',
  '{min} out of {total} found this helpful':
    '{min} dari {total} menganggap ini berguna.',
  'No data': 'Tidak ada data',
  'Please fill out the form with as many details as possible':
    'Silakan isi formulir dengan sedetail mungkin.',
  'feedback type': 'Jenis umpan balik',
  'Select your feedback type': 'Pilih jenis umpan balikmu',
  'Select your {value}': 'Pilih {value} mu',
  'Cannot be blank': 'Tidak bisa kosong',
  'Character limit exceeded': 'Batas karakter terlampaui',
  'Please enter a valid email': 'Masukkan email yang benar',
  success: 'Sukses',
  fail: 'Gagal',
  complete: 'Selesai',
  error: 'Kesalahan',
  close: 'Tutup',
  leave: 'Tinggalkan',
  stay: 'Tetap di Sini',
  cancel: 'Batal',
  'You will not be able to receive a reply after it is closed':
    'Kamu tidak akan dapat menerima balasan setelah ditutup.',
  'Image uploading failed': 'Unggah gambar gagal',
  'Image reviewing failed': 'Gagal mengunggah. Pastikan gambar kamu relevan dan pantas.',
  'You can only upload a maximum of {limit} images':
    'Kamu hanya dapat mengupload maksimal {limit} gambar',
  'Please check if the image format is .JPG or .PNG':
    'Periksa apakah format gambarnya .JPG atau .PNG.',
  'File uploading failed': 'Unggah file gagal',
  'File reviewing failed': 'Unggah file gagal. Pastikan file kamu relevan dan pantas.',
  'You can only upload a maximum of {limit} files':
    'Kamu hanya dapat mengupload maksimal {limit} file',
  'Please check the file format': 'Periksa format file',
  Note: 'Pemberitahuan',
  'Do you want to submit the current feedback':
    'Apa kamu ingin mengirimkan umpan balik saat ini?',
  'A customer service representative will reply within {hour} hours':
    'Perwakilan layanan pelanggan akan membalas dalam {hour} jam.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'Umpan balik ini akan ditutup. Silakan membuat evaluasi yang komprehensif.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Umpan balikmu telah berakhir karena melebihi batas waktu. Jika kamu memiliki pertanyaan, silakan buat umpan balik baru. Terima kasih!',
  'Do you want to close the current feedback':
    'Apakah kamu ingin menutup umpan balik saat ini?',
  'Rate Service': 'Nilai Layanan',
  'Are you satisfied with our service': 'Apakah kamu puas dengan layanan kami?',
  'Thank you for your feedback! We will continue to improve our service':
    'Terima kasih atas tanggapanmu! Kami akan terus meningkatkan layanan kami.',
  'You already rated this customer service less than {hour} hours ago':
    'Kamu sudah memberi nilai pada layanan pelanggan ini kurang dari {hour} jam yang lalu.',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Terima kasih atas tanggapanmu! Kami akan terus membantumu memecahkan masalah.',
  'Return to top': 'Kembali ke atas',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Kesalahan sistem (T_T)
Harap buka kembali halaman Umpan Balik dengan membuka Aplikasi {AppName} → Pusat Bantuan.
`,
  'System error. Sign expired.': 'Sistem bermasalah. Tanda kadaluwarsa.'
}

// 泰语
const Thai = {
  solved: 'แก้ไขแล้ว',
  unsolved: 'ยังไม่ได้แก้ไข',
  helpful: 'มีประโยชน์',
  'not helpful': 'ไม่เป็นประโยชน์',
  'new feedback': 'คำติชมใหม่',
  'tip question1': 'สวัสดี',
  'tip question2': 'เราสามารถช่วยเหลืออะไรได้บ้าง',
  more: 'อีก',
  feedback: 'ความคิดเห็น',
  'feedback tip':
    'กรุณากรอกแบบฟอร์มโดยให้มีรายละเอียดมากที่สุดเท่าที่จะเป็นไปได้',
  'question type': 'ประเภทคำถาม',
  'email address': 'ที่อยู่อีเมล์',
  description: 'คำอธิบาย',
  images: 'ภาพถ่าย',
  submit: 'ส่ง',
  'feedback history': 'ประวัติความเป็นมาของการตอบกลับ',
  'feedback id': 'รหัสคำติชม',
  'rate our service': 'ให้คะแนนบริการของเราหน่อยได้ไหมคะ',
  Rated: 'ให้คะแนนแล้ว',
  'Reasons for dissatisfaction': 'เหตุผลที่ไม่พอใจ',
  'Please input your feedback': 'กรุณากรอกความคิดเห็นของคุณ',
  processing: 'การประมวลผล',
  'wait for your reply': 'กำลังรอคำตอบของคุณ',
  'leave some comments on our service':
    'โปรดแสดงความคิดเห็นเกี่ยวกับบริการของเรา',
  collapse: 'ทรุด',
  'service detail': 'รายละเอียดบริการ',
  notification: 'การประกาศ',
  'submit modal tip':
    'ขอบคุณสำหรับความคิดเห็นของคุณ ทางเราจะติดต่อกลับโดยเร็วที่สุด',
  confirm: 'ยืนยัน',
  'satisfaction modal tip': `ความพึงพอใจของคุณเป็นกำลังใจให้เรามากที่สุด
  โปรดให้คะแนนเราที่ร้านค้า`,
  'thank rate': 'ขอบคุณสำหรับการให้คะแนนของคุณ! เราจะพัฒนาบริการของเราต่อไป',
  'tip close':
    'หากเรื่องนี้ได้ถูกปิดไปแล้ว คุณจะไม่สามารถรับการตอบกลับได้อีกต่อไป',
  back: 'กลับ',
  send: 'ส่ง',
  'select faq type': 'เลือกประเภทของปัญหา',
  'network error':
    'การเชื่อมต่อเครือข่ายของคุณไม่เสถียร กรุณาลองใหม่อีกครั้งในภายหลัง',

  hello: 'สวัสดี',
  'What can we do to help': 'เราสามารถช่วยเหลืออะไรได้บ้าง',
  Search: 'ค้นหา',
  'Contact Us': 'ติดต่อเรา',
  'Nothing more to load': 'ไม่มีเนื้อหาเพิ่มเติมให้โหลดแล้ว',
  'Search Result': 'ผลการค้นหา',
  'Found {value} results': 'พบผลลัพธ์ {value} รายการ',
  'No results for': 'ไม่พบผลลัพธ์',
  'Related results': 'ผลลัพธ์ที่เกี่ยวข้อง',
  'Still need help': 'ยังต้องการความช่วยเหลืออยู่หรือไม่',
  'Thanks for your feedback': 'ขอบคุณสำหรับคำติชมของคุณ!',
  'FAQ Content': 'เนื้อหาคำถามที่พบบ่อย',
  'Was this article helpful': 'บทความนี้มีประโยชน์หรือไม่?',
  No: 'ไม่ใช่',
  Yes: 'ใช่',
  '{min} out of {total} found this helpful':
    '{min} จาก {total} คนพบว่าข้อมูลนี้มีประโยชน์',
  'No data': 'ไม่มีข้อมูล',
  'Please fill out the form with as many details as possible':
    'กรุณากรอกแบบฟอร์มโดยให้มีรายละเอียดมากที่สุดเท่าที่จะเป็นไปได้',
  'feedback type': 'ประเภทความคิดเห็น',
  'Select your feedback type': 'เลือกประเภทคำติชมของคุณ',
  'Select your {value}': 'เลือก {value} ของคุณ',
  'Cannot be blank': 'ไม่สามารถเว้นว่างได้',
  'Character limit exceeded': 'เกินจำนวนอักขระสูงสุด',
  'Please enter a valid email': 'โปรดป้อนอีเมลที่ถูกต้อง',
  success: 'ความสำเร็จ',
  fail: 'ความล้มเหลว',
  complete: 'สมบูรณ์',
  error: 'ข้อผิดพลาด',
  close: 'ปิด',
  leave: 'ออกจาก',
  stay: 'อยู่ในที่เดิม',
  cancel: 'ยกเลิก',
  'You will not be able to receive a reply after it is closed':
    'คุณจะไม่สามารถรับการตอบกลับได้หลังจากมันถูกปิดแล้ว',
  'Image uploading failed': 'การอัพโหลดรูปภาพล้มเหลว',
  'Image reviewing failed': 'อัปโหลดล้มเหลว โปรดตรวจสอบว่าภาพของคุณเกี่ยวข้องและเหมาะสม',
  'You can only upload a maximum of {limit} images':
    'คุณสามารถอัปโหลดรูปภาพได้สูงสุด {limit} รูปภาพเท่านั้นค่ะ/ครับ',
  'Please check if the image format is .JPG or .PNG':
    'โปรดตรวจสอบว่ารูปแบบไฟล์เป็น .JPG หรือ .PNG ค่ะ',
  'File uploading failed': 'การอัพโหลดไฟล์ล้มเหลว',
  'File reviewing failed': 'อัปโหลดล้มเหลว. โปรดตรวจสอบว่าคุณมีไฟล์ที่เกี่ยวข้องและเหมาะสม',
  'You can only upload a maximum of {limit} files':
    'คุณสามารถอัพโหลดไฟล์ได้สูงสุด {limit} ไฟล์เท่านั้น',
  'Please check the file format': 'กรุณาตรวจสอบรูปแบบไฟล์',
  Note: 'การประกาศ',
  'Do you want to submit the current feedback':
    'คุณต้องการส่งเนื้อหาปัจจุบันหรือไม่',
  'A customer service representative will reply within {hour} hours':
    'ตัวแทนบริการลูกค้าจะตอบกลับภายใน {hour} ชั่วโมง',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'ข้อติชมนี้จะถูกปิดไปแล้ว กรุณาทำการประเมินอย่างครบถ้วน',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'คำติชมของคุณได้สิ้นสุดลงเนื่องจากเกินเวลาที่กำหนดไว้ หากคุณมีคำถามใด ๆ กรุณาสร้างคำติชมใหม่ ขอบคุณ!',
  'Do you want to close the current feedback':
    'คุณต้องการปิดการตอบกลับปัจจุบันหรือไม่?',
  'Rate Service': 'โปรดให้คะแนนบริการของเรา',
  'Are you satisfied with our service': 'คุณพึงพอใจกับบริการของเราหรือไม่?',
  'Thank you for your feedback! We will continue to improve our service':
    'ขอบคุณสำหรับคำติชมของคุณ! เราจะพัฒนาบริการของเราต่อไป',
  'You already rated this customer service less than {hour} hours ago':
    'คุณได้ให้คะแนนบริการลูกค้านี้ไปแล้วในเวลาน้อยกว่า {hour} ชั่วโมงที่ผ่านมาแล้วค่ะ',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'ขอบคุณสำหรับคำติชมของคุณ! เราจะดำเนินการช่วยคุณแก้ไขปัญหาต่อไป',
  'Return to top': 'กลับไปที่ด้านบน',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `้อผิดพลาดของระบบ (T_T)
โปรดเปิดหน้าต่างของหน้าตอบกลับอีกครั้งโดยไปที่แอป {AppName} → ศูนย์ช่วยเหลือ.`,
  'System error. Sign expired.': 'ข้อผิดพลาดของระบบ หมดอายุการเข้าใช้งาน',
  /* 网络状态 */
  'Network Status': 'สถานะเครือข่าย',
  Testing: 'ทดสอบ',
  'Please allow us to access your network status information to help solve the issue.':
    'กรุณาอนุญาตให้เราเข้าถึงข้อมูลสถานะเครือข่ายของคุณเพื่อช่วยแก้ไขปัญหา',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'กำลังทดสอบเครือข่าย อาจใช้เวลา 10–30 วินาที กรุณารอ',
  'Done! Thank you!': 'เสร็จแล้ว! ขอบคุณ!',
  OK: 'ตกลง'
}

// 阿拉伯语
const Arabic = {
  solved: 'تم الحل',
  unsolved: 'غير محلول',
  helpful: 'مفيد',
  'not helpful': 'غير مفيد',
  'tip question1': 'مرحبًا، أيها المستخدم',
  'tip question2': 'ماذا تحتاج إلى المساعدة به؟',
  'new feedback': 'تعليق جديد',
  more: 'المزيد',
  feedback: 'تعليق',
  'feedback tip': 'يرجى ملء النموذج بأكبر قدر ممكن من التفاصيل',
  'question type': 'نوع السؤال',
  'email address': 'عنوان البريد الإلكتروني',
  description: 'الوصف',
  images: 'الصور',
  submit: 'إرسال',
  'feedback history': 'تاريخ التعليقات',
  'feedback id': 'رقم التعليق',
  'rate our service': 'قيّم خدمتنا',
  Rated: 'تم التقييم',
  'Reasons for dissatisfaction': 'أسباب عدم الرضا',
  'Please input your feedback': 'يرجى إدخال ملاحظاتك',
  processing: 'قيد المعالجة',
  'wait for your reply': 'في انتظار ردك',
  'leave some comments on our service': 'اترك تعليقًا على خدمتنا',
  collapse: 'طي',
  'service detail': 'تفاصيل الخدمة',
  notification: 'الإشعارات',
  'submit modal tip': 'شكرًا على تعليقك، وسنعاود الاتصال بك في أقرب وقت ممكن.',
  confirm: 'تأكيد',
  'satisfaction modal tip': `رضاك هو أكبر تشجيع لنا. قيمنا في المتجر!`,
  'thank rate': 'شكرًا على تقييمك! سنعمل على تحسين خدماتنا.',
  'tip close': 'لن تتمكن من تلقي رد بعد إغلاق هذه المشكلة',
  back: 'رجوع',
  send: 'إرسال',
  'select faq type': 'اختر نوع المشكلة',
  'network error': 'اتصال الشبكة غير مستقر. يرجى المحاولة لاحقًا.',

  hello: 'مرحبًا',
  'What can we do to help': 'كيف يمكننا مساعدتك؟',
  Search: 'بحث',
  'Contact Us': 'اتصل بنا',
  'Nothing more to load': 'لا يوجد المزيد للتحميل.',
  'Search Result': 'نتيجة البحث',
  'Found {value} results': 'تم العثور على {value} النتائج',
  'No results for': 'لم يتم العثور على النتائج',
  'Related results': 'نتائج ذات صلة',
  'Still need help': 'ما زلت بحاجة إلى مساعدة؟',
  'Thanks for your feedback': 'شكرًا على تعليقك!',
  'FAQ Content': 'محتوى الأسئلة الشائعة',
  'Was this article helpful': 'هل كانت هذه المقالة مفيدة؟',
  No: 'لا',
  Yes: 'نعم',
  '{min} out of {total} found this helpful': '{min} من {total} وجدت هذا مفيدًا',
  'No data': 'لا توجد بيانات',
  'Please fill out the form with as many details as possible':
    'يرجى ملء النموذج بأكبر قدر ممكن من التفاصيل',
  'feedback type': 'نوع التعليق',
  'Select your feedback type': 'اختر نوع التعليق',
  'Select your {value}': 'اختر {value}',
  'Cannot be blank': 'لا يمكن أن يكون فارغًا',
  'Character limit exceeded': 'تم تجاوز الحد الأقصى للأحرف',
  'Please enter a valid email': 'يرجى إدخال بريد إلكتروني صالح',
  success: 'نجاح',
  fail: 'فشل',
  complete: 'اكتمال',
  error: 'خطأ',
  close: 'إغلاق',
  leave: 'مغادرة',
  stay: 'البقاء',
  cancel: 'إلغاء',
  'You will not be able to receive a reply after it is closed':
    'لن تتمكن من تلقي رد بعد إغلاقه',
  'Image uploading failed': 'فشل تحميل الصورة',
  'Image reviewing failed': 'فشل التحميل. يرجى التأكد من أن الصورة ذات صلة ومناسبة.',
  'You can only upload a maximum of {limit} images':
    'يمكنك تحميل حد أقصى {limit} من الصور',
  'Please check if the image format is .JPG or .PNG':
    'يرجى التحقق من أن تنسيق الصورة هو .JPG أو .PNG.',
  'File uploading failed': 'فشل تحميل الملف',
  'File reviewing failed': 'فشل التحميل. يرجى التأكد من أن الملف ذات صلة ومناسبة.',
  'You can only upload a maximum of {limit} files':
    'يمكنك تحميل حد أقصى {limit} من الملفات',
  'Please check the file format': 'يرجى التحقق من تنسيق الملف',
  Note: 'ملاحظة',
  'Do you want to submit the current feedback':
    'هل تريد إرسال التعليق الحالي؟',
  'A customer service representative will reply within {hour} hours':
    'سيقوم ممثل خدمة العملاء بالرد خلال {hour} ساعة.',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'سيتم إغلاق هذا التعليق. يرجى إجراء تقييم شامل.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'انتهى تعليقك لتجاوز الحد الزمني. إذا كان لديك أي أسئلة، يرجى إنشاء تعليق جديد. شكرًا لك!',
  'Do you want to close the current feedback':
    'هل تريد إغلاق التعليق الحالي؟',
  'Rate Service': 'تقييم الخدمة',
  'Are you satisfied with our service': 'هل أنت راضٍ عن خدمتنا؟',
  'Thank you for your feedback! We will continue to improve our service': 'شكرًا على تعليقك! سنواصل تحسين خدمتنا',
  'You already rated this customer service less than {hour} hours ago': 'لقد قيمت خدمة العملاء هذه منذ أقل من {hour} ساعة',
  'Thank you for your feedback! We will continue to help you solve the problem': 'شكرًا على تعليقك! سنواصل مساعدتك في حل المشكلة.',
  'Return to top': 'العودة إلى الأعلى',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `خطأ في النظام (T_T). يرجى إعادة فتح صفحة التعليقات من خلال التطبيق {AppName} → مركز المساعدة.`,
  'System error. Sign expired.': 'خطأ في النظام. انتهت صلاحية التوقيع.',
  /* 网络状态 */
  'Network Status': 'حالة الشبكة',
  Testing: 'اختبار',
  'Please allow us to access your network status information to help solve the issue.':
    'يرجى السماح لنا بالوصول إلى معلومات حالة الشبكة الخاصة بك للمساعدة في حل المشكلة.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'يجري اختبار الشبكة. قد يستغرق 10-30 ثانية. يرجى الانتظار.',
  'Done! Thank you!': 'تم! شكراً لك!',
  OK: 'حسناً'
}

// 罗马尼亚语
const Romanian = {
  solved: 'Rezolvat',
  unsolved: 'Nerezolvat',
  helpful: 'Helpful',
  'not helpful': 'Not helpful',
  'new feedback': 'Feedback nou',
  'tip question1': 'Salut, utilizator',
  'tip question2': 'Cu ce ai nevoie de ajutor?',
  more: 'Mai mult',
  feedback: 'Feedback',
  'feedback tip': 'Te rugăm să completezi formularul cu cât mai multe detalii posibile',
  'question type': 'Tipul întrebării',
  'email address': 'Adresă de e-mail',
  description: 'Descriere',
  images: 'Imagini',
  submit: 'Trimite',
  'feedback history': 'Istoricul feedback-ului',
  'feedback id': 'ID feedback',
  'rate our service': 'Evaluează serviciul nostru',
  Rated: 'Evaluat',
  'Reasons for dissatisfaction': 'Motive de nemulțumire',
  'Please input your feedback': 'Introdu feedbackul tău',
  processing: 'Se procesează',
  'wait for your reply': 'Așteptând răspunsul tău',
  'leave some comments on our service': 'Lasă un comentariu despre serviciul nostru',
  collapse: 'Restrânge',
  'service detail': 'Detalii serviciu',
  notification: 'Notificare',
  'submit modal tip': 'Îți mulțumim pentru feedback și îți vom răspunde cât mai curând posibil.',
  confirm: 'Confirmă',
  'satisfaction modal tip': `Satisfacția ta este cea mai mare încurajare pentru noi.
  Evaluează-ne în magazin!`,
  'thank rate': 'Îți mulțumim pentru evaluare! Ne vom îmbunătăți serviciile.',
  'tip close': 'Nu vei mai putea primi un răspuns pentru această problemă după ce a fost închisă.',
  back: 'Înapoi',
  send: 'Trimite',
  'select faq type': 'Selectează un tip de problemă',
  'network error': 'Conexiunea ta la rețea este instabilă. Te rugăm să încerci din nou mai târziu.',

  hello: 'Salut,',
  'What can we do to help': 'Cu ce te putem ajuta?',
  Search: 'Căutare',
  'Contact Us': 'Contactează-ne',
  'Nothing more to load': 'Nimic mai mult de încărcat.',
  'Search Result': 'Rezultat căutare',
  'Found {value} results': 'S-au găsit {value} rezultate',
  'No results for': 'Niciun rezultat găsit pentru',
  'Related results': 'Rezultate similare',
  'Still need help': 'Mai ai nevoie de ajutor?',
  'Thanks for your feedback': 'Mulțumim pentru feedback!',
  'FAQ Content': 'Conținut FAQ',
  'Was this article helpful': 'A fost util acest articol?',
  No: 'Nu',
  Yes: 'Da',
  '{min} out of {total} found this helpful': '{min} din {total} au considerat util',
  'No data': 'Nicio dată',
  'Please fill out the form with as many details as possible':
    'Te rugăm să completezi formularul cu cât mai multe detalii posibile.',
  'feedback type': 'Tip feedback',
  'Select your feedback type': 'Selectează tipul de feedback',
  'Select your {value}': 'Selectează {value}-ul tău',
  'Cannot be blank': 'Nu poate fi gol',
  'Character limit exceeded': 'Limită de caractere depășită',
  'Please enter a valid email': 'Te rugăm să introduci un e-mail valid',
  success: 'Succes',
  fail: 'Eșec',
  complete: 'Finalizat',
  error: 'Eroare',
  close: 'Închide',
  leave: 'Pleacă',
  stay: 'Rămâi',
  cancel: 'Anulează',
  'You will not be able to receive a reply after it is closed':
    'Nu vei mai putea primi un răspuns după ce este închis.',
  'Image uploading failed': 'Încărcarea imaginii a eșuat',
  'Image reviewing failed': 'Încărcare eșuată. Asigură-te că imaginea este relevantă și adecvată.',
  'You can only upload a maximum of {limit} images':
    'Poți încărca maximum {limit} imagini',
  'Please check if the image format is .JPG or .PNG':
    'Te rugăm să verifici dacă formatul imaginii este .JPG sau .PNG',
  'File uploading failed': 'Încărcarea fișierului a eșuat',
  'File reviewing failed': 'Încărcare eșuată. Asigură-te că fișierul este relevant și adecvat.',
  'You can only upload a maximum of {limit} files':
    'Poți încărca maximum {limit} fișiere',
  'Please check the file format': 'Te rugăm să verifici formatul fișierului',
  Note: 'Notificare',
  'Do you want to submit the current feedback':
    'Vrei să trimiți feedback-ul curent?',
  'A customer service representative will reply within {hour} hours':
    'Un reprezentant al serviciului clienți îți va răspunde în {hour} ore',
  'This feedback will be closed. Please make a comprehensive evaluation':
    'ขAcest feedback va fi închis. Te rugăm să faci o evaluare completă',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you':
    'Feedback-ul tău a fost încheiat deoarece a depășit limita de timp. Dacă ai întrebări, te rugăm să creezi un nou feedback. Mulțumim!',
  'Do you want to close the current feedback':
    'Vrei să închizi feedback-ul curent?',
  'Rate Service': 'Evaluează serviciul',
  'Are you satisfied with our service': 'Ești mulțumit de serviciul nostru?',
  'Thank you for your feedback! We will continue to improve our service':
    'Îți mulțumim pentru feedback! Vom continua să ne îmbunătățim serviciul.',
  'You already rated this customer service less than {hour} hours ago':
    'Ai evaluat deja acest serviciu cu mai puțin de {hour} ore în urmă',
  'Thank you for your feedback! We will continue to help you solve the problem':
    'Îți mulțumim pentru feedback! Vom continua să te ajutăm să rezolvi problema',
  'Return to top': 'Înapoi sus',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Eroare de sistem (T_T)
Te rugăm să redeschizi pagina de Feedback accesând aplicația {AppName} → Centrul de ajutor.`,
  'System error. Sign expired.': 'Eroare de sistem. Semnătura a expirat.',
  /* 网络状态 */
  'Network Status': 'Stare rețea',
  Testing: 'Testare',
  'Please allow us to access your network status information to help solve the issue.':
    'Te rugăm să ne permiți accesul la informațiile despre starea rețelei pentru a ajuta la rezolvarea problemei',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.':
    'Testarea rețelei este în curs. Poate dura 10–30 de secunde. Te rugăm să aștepți',
  'Done! Thank you!': 'Gata! Mulțumim!',
  OK: 'OK'
}

// 捷克语
const Czech = {
  solved: 'Vyřešeno',
  unsolved: 'Nevyřešeno',
  helpful: 'Užitočné',
  'not helpful': 'Neužitečné',
  'new feedback': 'Nová zpětná vazba',
  'tip question1': 'Ahoj, uživateli',
  'tip question2': 'S čím potřebujete pomoc?',
  more: 'Více',
  feedback: 'Zpětná vazba',
  'feedback tip': 'Vyplňte prosím formulář co nejpodrobněji.',
  'question type': 'Typ otázky',
  'email address': 'E-mailová adresa',
  description: 'Popis',
  images: 'Obrázky',
  submit: 'Odeslat',
  'feedback history': 'Historie zpětné vazby',
  'feedback id': 'ID zpětné vazby',
  'rate our service': 'Ohodnoťte naši službu',
  Rated: 'Ohodnoceno',
  'Reasons for dissatisfaction': 'Důvody nespokojenosti',
  'Please input your feedback': 'Zadejte svou zpětnou vazbu',
  processing: 'Zpracovává se',
  'wait for your reply': 'Čeká se na vaši odpověď',
  'leave some comments on our service': 'Zanechte komentář ke službě',
  collapse: 'Sbalit',
  'service detail': 'Detail služby',
  notification: 'Oznámení',
  'submit modal tip': 'Děkujeme za vaši zpětnou vazbu. Ozveme se vám co nejdříve.',
  confirm: 'Potvrdit',
  'satisfaction modal tip': `Vaše spokojenost je naším největším povzbuzením. 
  Ohodnoťte nás v obchodě!`,
  'thank rate': 'Děkujeme za vaše hodnocení! Zlepšíme naše služby.',
  'tip close': 'Po uzavření této záležitosti již nebudete moci obdržet odpověď.',
  back: 'Zpět',
  send: 'Odeslat',
  'select faq type': 'Vyberte typ problému',
  'network error': 'Vaše síťové připojení je nestabilní. Zkuste to prosím později.',

  hello: 'Ahoj,',
  'What can we do to help': 'S čím vám můžeme pomoci?',
  Search: 'Hledat',
  'Contact Us': 'Kontaktujte nás',
  'Nothing more to load': 'Nic dalšího k načtení.',
  'Search Result': 'Výsledek hledání',
  'Found {value} results': 'Nalezeno {value} výsledků',
  'No results for': 'Nebyly nalezeny žádné výsledky pro',
  'Related results': 'Související výsledky',
  'Still need help': 'Potřebujete stále pomoc?',
  'Thanks for your feedback': 'Děkujeme za vaši zpětnou vazbu!',
  'FAQ Content': 'Obsah FAQ',
  'Was this article helpful': 'Byl tento článek užitečný?',
  No: 'Ne',
  Yes: 'Ano',
  '{min} out of {total} found this helpful': '{min} z {total} považuje toto za užitečné.',
  'No data': 'Žádná data',
  'Please fill out the form with as many details as possible': 'Vyplňte prosím formulář co nejpodrobněji.',
  'feedback type': 'Typ zpětné vazby',
  'Select your feedback type': 'Vyberte typ vaší zpětné vazby',
  'Select your {value}': 'Vyberte váš {value}',
  'Cannot be blank': 'Nemůže být prázdné',
  'Character limit exceeded': 'Překročen limit znaků',
  'Please enter a valid email': 'Zadejte prosím platný e-mail',
  success: 'Úspěch',
  fail: 'Selhání',
  complete: 'Dokončeno',
  error: 'Chyba',
  close: 'Zavřít',
  leave: 'Odejít',
  stay: 'Zůstat',
  cancel: 'Zrušit',
  'You will not be able to receive a reply after it is closed': 'Po uzavření již nebudete moci obdržet odpověď.',
  'Image uploading failed': 'Nahrávání obrázku selhalo.',
  'Image reviewing failed': 'Nahrávání selhalo. Ujistěte se prosím, že je váš obrázek relevantní a vhodný.',
  'You can only upload a maximum of {limit} images': 'Můžete nahrát maximálně {limit} obrázků.',
  'Please check if the image format is .JPG or .PNG': 'Zkontrolujte prosím, zda je formát obrázku .JPG nebo .PNG.',
  'File uploading failed': 'Nahrávání souboru selhalo',
  'File reviewing failed': 'Nahrávání selhalo. Ujistěte se prosím, že je váš soubor relevantní a vhodný.',
  'You can only upload a maximum of {limit} files': 'Můžete nahrát maximálně {limit} souborů',
  'Please check the file format': 'Zkontrolujte prosím formát souboru',
  Note: 'Upozornění',
  'Do you want to submit the current feedback': 'Chcete odeslat aktuální zpětnou vazbu?',
  'A customer service representative will reply within {hour} hours': 'Zástupce zákaznické podpory odpoví do {hour} hodin.',
  'This feedback will be closed. Please make a comprehensive evaluation': 'Tato zpětná vazba bude uzavřena. Proveďte prosím komplexní hodnocení.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you': 'Vaše zpětná vazba byla ukončena z důvodu překročení časového limitu. Pokud máte další otázky, vytvořte prosím novou zpětnou vazbu. Děkujeme!',
  'Do you want to close the current feedback': 'Chcete uzavřít aktuální zpětnou vazbu?',
  'Rate Service': 'Ohodnoťte službu',
  'Are you satisfied with our service': 'Jste spokojeni s naší službou?',
  'Thank you for your feedback! We will continue to improve our service': 'Děkujeme za vaši zpětnou vazbu! Budeme nadále zlepšovat naše služby.',
  'You already rated this customer service less than {hour} hours ago': 'Již jste ohodnotili tuto zákaznickou službu před méně než {hour} hodinami.',
  'Thank you for your feedback! We will continue to help you solve the problem': 'Děkujeme za vaši zpětnou vazbu! Budeme vás nadále podporovat při řešení problému.',
  'Return to top': 'Návrat na začátek',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Systémová chyba (T_T)
Otevřete prosím stránku zpětné vazby znovu přes {AppName} App → Centrum nápovědy.`,
  'System error. Sign expired.': 'Systémová chyba. Platnost přihlášení vypršela.',
  /* 网络状态 */
  'Network Status': 'Stav sítě',
  Testing: 'Testování',
  'Please allow us to access your network status information to help solve the issue.': 'Umožněte nám prosím přístup k informacím o stavu vaší sítě, abychom mohli problém vyřešit.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.': 'Probíhá testování sítě. Může trvat 10–30 sekund. Prosím čekejte.',
  'Done! Thank you!': 'Hotovo! Děkujeme!',
  OK: 'OK'
}

// 保加利亚语
const Bulgarian = {
  solved: 'Решено',
  unsolved: 'Нерешено',
  helpful: 'Полезно',
  'not helpful': 'Не е полезно',
  'new feedback': 'Нова обратна връзка',
  'tip question1': 'Здравей, потребителю',
  'tip question2': 'С какво имате нужда от помощ?',
  more: 'Повече',
  feedback: 'Обратна връзка',
  'feedback tip': 'Моля, попълнете формуляра с колкото се може повече детайли',
  'question type': 'Тип въпрос',
  'email address': 'Имейл адрес',
  description: 'Описание',
  images: 'Изображения',
  submit: 'Изпрати',
  'feedback history': 'История на обратната връзка',
  'feedback id': 'ID на обратната връзка',
  'rate our service': 'Оценете нашата услуга',
  Rated: 'Оценено',
  'Reasons for dissatisfaction': 'Причини за недоволство',
  'Please input your feedback': 'Моля, въведете вашата обратна връзка',
  processing: 'Обработва се',
  'wait for your reply': 'Очаква се вашият отговор',
  'leave some comments on our service': 'Оставете коментар за нашата услуга',
  collapse: 'Свий',
  'service detail': 'Подробности за услугата',
  notification: 'Известие',
  'submit modal tip': 'Благодарим ви за обратната връзка. Ще се свържем с вас възможно най-скоро.',
  confirm: 'Потвърдете',
  'satisfaction modal tip': `Вашето удовлетворение е най-голямото ни стимулиране. 
  Оценете ни в магазина!`,
  'thank rate': 'Благодарим ви за оценката! Ще подобрим нашите услуги.',
  'tip close': 'След като този проблем бъде затворен, вече няма да можете да получите отговор.',
  back: 'Обратно',
  send: 'Изпрати',
  'select faq type': 'Изберете тип проблем',
  'network error': 'Вашата мрежова връзка е нестабилна. Моля, опитайте по-късно.',

  hello: 'Здравейте,',
  'What can we do to help': 'С какво можем да помогнем?',
  Search: 'Търсене',
  'Contact Us': 'Свържете се с нас',
  'Nothing more to load': 'Няма повече резултати за зареждане.',
  'Search Result': 'Резултат от търсенето',
  'Found {value} results': 'Намерени {value} резултата',
  'No results for': 'Няма намерени резултати за',
  'Related results': 'Свързани резултати',
  'Still need help': 'Все още имате нужда от помощ?',
  'Thanks for your feedback': 'Благодарим ви за обратната връзка!',
  'FAQ Content': 'Съдържание на FAQ',
  'Was this article helpful': 'Тази статия беше ли полезна?',
  No: 'Не',
  Yes: 'Да',
  '{min} out of {total} found this helpful': '{min} от {total} намериха това за полезно.',
  'No data': 'Няма данни',
  'Please fill out the form with as many details as possible': 'Моля, попълнете формуляра с колкото се може повече детайли.',
  'feedback type': 'Тип обратна връзка',
  'Select your feedback type': 'Изберете тип обратна връзка',
  'Select your {value}': 'Изберете вашия {value}',
  'Cannot be blank': 'Не може да е празно',
  'Character limit exceeded': 'Надвишен лимит на символите',
  'Please enter a valid email': 'Моля, въведете валиден имейл',
  success: 'Успешно',
  fail: 'Неуспешно',
  complete: 'Завършено',
  error: 'Грешка',
  close: 'Затвори',
  leave: 'Напусни',
  stay: 'Остани',
  cancel: 'Отказ',
  'You will not be able to receive a reply after it is closed': 'След затваряне вече няма да можете да получите отговор.',
  'Image uploading failed': 'Качването на изображението не беше успешно',
  'Image reviewing failed': 'Качването не беше успешно. Моля, уверете се, че изображението е релевантно и подходящо.',
  'You can only upload a maximum of {limit} images': 'Можете да качите максимум {limit} изображения',
  'Please check if the image format is .JPG or .PNG': 'Моля, проверете дали форматът на изображението е .JPG или .PNG.',
  'File uploading failed': 'Качването на файла не беше успешно',
  'File reviewing failed': 'Качването не беше успешно. Моля, уверете се, че файлът е релевантен и подходящ.',
  'You can only upload a maximum of {limit} files': 'Можете да качите максимум {limit} файла',
  'Please check the file format': 'Моля, проверете формата на файла',
  Note: 'Уведомление',
  'Do you want to submit the current feedback': 'Искате ли да изпратите текущата обратна връзка?',
  'A customer service representative will reply within {hour} hours': 'Представител на клиентската поддръжка ще отговори в рамките на {hour} часа.',
  'This feedback will be closed. Please make a comprehensive evaluation': 'Тази обратна връзка ще бъде затворена. Моля, направете комплексна оценка.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you': 'Вашата обратна връзка приключи поради изтичане на времето. Ако имате въпроси, създайте нова обратна връзка. Благодарим!',
  'Do you want to close the current feedback': 'Искате ли да затворите текущата обратна връзка?',
  'Rate Service': 'Оценете услугата',
  'Are you satisfied with our service': 'Доволни ли сте от нашата услуга?',
  'Thank you for your feedback! We will continue to improve our service': 'Благодарим ви за обратната връзка! Ще продължим да подобряваме услугата си.',
  'You already rated this customer service less than {hour} hours ago': 'Вече сте оценили тази клиентска услуга преди по-малко от {hour} часа.',
  'Thank you for your feedback! We will continue to help you solve the problem': 'Благодарим ви за обратната връзка! Ще продължим да ви помагаме при решаването на проблема.',
  'Return to top': 'Връщане в началото',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Системна грешка (T_T)
Моля, отворете страницата за обратна връзка отново чрез {AppName} App → Център за помощ.`,
  'System error. Sign expired.': 'Системна грешка. Влизането е изтекло.',
  /* 网络状态 */
  'Network Status': 'Статус на мрежата',
  Testing: 'Тестване',
  'Please allow us to access your network status information to help solve the issue.': 'Моля, позволете ни достъп до информация за статуса на вашата мрежа, за да помогнем за решаването на проблема.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.': 'Провежда се тест на мрежата. Може да отнеме 10–30 секунди. Моля, изчакайте.',
  'Done! Thank you!': 'Готово! Благодарим!',
  OK: 'OK'
}

// 越南语
const Vietnamese = {
  solved: 'Đã giải quyết',
  unsolved: 'Chưa giải quyết',
  helpful: 'Hữu ích',
  'not helpful': 'Không hữu ích',
  'new feedback': 'Phản hồi mới',
  'tip question1': 'Xin chào, người dùng',
  'tip question2': 'Bạn cần giúp gì?',
  more: 'Thêm nữa',
  feedback: 'Phản hồi',
  'feedback tip': 'Vui lòng điền vào biểu mẫu với đầy đủ chi tiết nhất có thể.',
  'question type': 'Loại câu hỏi',
  'email address': 'Địa chỉ email',
  description: 'Mô tả',
  images: 'Hình ảnh',
  submit: 'Gửi đi',
  'feedback history': 'Lịch sử phản hồi',
  'feedback id': 'ID phản hồi',
  'rate our service': 'Đánh giá dịch vụ của chúng tôi',
  Rated: 'Đã đánh giá',
  'Reasons for dissatisfaction': 'Lý do không hài lòng',
  'Please input your feedback': 'Vui lòng nhập phản hồi của bạn',
  processing: 'Đang xử lý',
  'wait for your reply': 'Đang chờ phản hồi của bạn',
  'leave some comments on our service': 'Để lại bình luận về dịch vụ của chúng tôi',
  collapse: 'Thu gọn',
  'service detail': 'Chi tiết dịch vụ',
  notification: 'Thông báo',
  'submit modal tip': 'Cảm ơn bạn đã phản hồi, chúng tôi sẽ liên hệ lại sớm nhất có thể.',
  confirm: 'Xác nhận',
  'satisfaction modal tip': `Sự hài lòng của bạn là động lực lớn nhất cho chúng tôi. 
  Hãy đánh giá chúng tôi trên cửa hàng!`,
  'thank rate': 'Cảm ơn bạn đã đánh giá! Chúng tôi sẽ cải thiện dịch vụ.',
  'tip close': 'Bạn sẽ không thể nhận được phản hồi cho vấn đề này sau khi nó được đóng lại.',
  back: 'Quay lại',
  send: 'Gửi',
  'select faq type': 'Chọn loại vấn đề',
  'network error': 'Kết nối mạng của bạn không ổn định. Vui lòng thử lại sau.',

  hello: 'Xin chào,',
  'What can we do to help': 'Chúng tôi có thể giúp gì cho bạn?',
  Search: 'Tìm kiếm',
  'Contact Us': 'Liên hệ với chúng tôi',
  'Nothing more to load': 'Không còn gì để tải.',
  'Search Result': 'Kết quả tìm kiếm',
  'Found {value} results': 'Tìm thấy {value} kết quả',
  'No results for': 'Không tìm thấy kết quả cho',
  'Related results': 'Kết quả liên quan',
  'Still need help': 'Cần giúp đỡ thêm không?',
  'Thanks for your feedback': 'Cảm ơn bạn đã phản hồi!',
  'FAQ Content': 'Nội dung Câu hỏi thường gặp',
  'Was this article helpful': 'Bài viết này có hữu ích không?',
  No: 'Không',
  Yes: 'Có',
  '{min} out of {total} found this helpful': '{min} trên {total} thấy hữu ích.',
  'No data': 'Không có dữ liệu',
  'Please fill out the form with as many details as possible': 'Vui lòng điền vào biểu mẫu với càng nhiều chi tiết càng tốt.',
  'feedback type': 'Loại phản hồi',
  'Select your feedback type': 'Chọn loại phản hồi của bạn',
  'Select your {value}': 'Chọn {value} của bạn',
  'Cannot be blank': 'Không được để trống',
  'Character limit exceeded': 'Vượt quá giới hạn ký tự',
  'Please enter a valid email': 'Vui lòng nhập email hợp lệ',
  success: 'Thành công',
  fail: 'Thất bại',
  complete: 'Hoàn thành',
  error: 'Lỗi',
  close: 'Đóng',
  leave: 'Rời đi',
  stay: 'Ở lại',
  cancel: 'Hủy',
  'You will not be able to receive a reply after it is closed': 'Bạn sẽ không nhận được phản hồi sau khi nó được đóng.',
  'Image uploading failed': 'Tải ảnh lên thất bại',
  'Image reviewing failed': 'Tải ảnh lên thất bại. Vui lòng đảm bảo ảnh của bạn có liên quan và phù hợp.',
  'You can only upload a maximum of {limit} images': 'Bạn chỉ có thể tải lên tối đa {limit} ảnh.',
  'Please check if the image format is .JPG or .PNG': 'Vui lòng kiểm tra xem định dạng ảnh có phải là .JPG hoặc .PNG không.',
  'File uploading failed': 'Tải tệp lên thất bại',
  'File reviewing failed': 'Tải tệp lên thất bại. Vui lòng đảm bảo tệp của bạn có liên quan và phù hợp.',
  'You can only upload a maximum of {limit} files': 'Bạn chỉ có thể tải lên tối đa {limit} tệp.',
  'Please check the file format': 'Vui lòng kiểm tra định dạng tệp.',
  Note: 'Thông báo',
  'Do you want to submit the current feedback': 'Bạn có muốn gửi phản hồi hiện tại không?',
  'A customer service representative will reply within {hour} hours': 'Nhân viên chăm sóc khách hàng sẽ trả lời trong vòng {hour} giờ.',
  'This feedback will be closed. Please make a comprehensive evaluation': 'Phản hồi này sẽ được đóng. Vui lòng đưa ra đánh giá toàn diện.',
  'Your feedback has ended due to timeout. If you have any questions, please create new feedback. Thank you': 'Phản hồi của bạn đã kết thúc do vượt quá thời gian giới hạn. Nếu bạn có bất kỳ câu hỏi nào, vui lòng tạo phản hồi mới. Cảm ơn bạn!',
  'Do you want to close the current feedback': 'Bạn có muốn đóng phản hồi hiện tại không?',
  'Rate Service': 'Đánh giá dịch vụ',
  'Are you satisfied with our service': 'Bạn có hài lòng với dịch vụ của chúng tôi không?',
  'Thank you for your feedback! We will continue to improve our service': 'Cảm ơn bạn đã phản hồi! Chúng tôi sẽ tiếp tục cải thiện dịch vụ của mình.',
  'You already rated this customer service less than {hour} hours ago': 'Bạn đã đánh giá dịch vụ khách hàng này cách đây chưa đầy {hour} giờ.',
  'Thank you for your feedback! We will continue to help you solve the problem': 'Cảm ơn bạn đã phản hồi! Chúng tôi sẽ tiếp tục giúp bạn giải quyết vấn đề.',
  'Return to top': 'Quay lại đầu trang',
  'System error. Please reopen the Feedback page by going to {AppName} App → Help Center.': `Lỗi hệ thống (T_T)
Vui lòng mở lại trang Phản hồi bằng cách vào {AppName} App → Trung tâm trợ giúp.`,
  'System error. Sign expired.': 'Lỗi hệ thống. Phiên đăng nhập đã hết hạn.',
  /* 网络状态 */
  'Network Status': 'Trạng thái mạng',
  Testing: 'Kiểm tra',
  'Please allow us to access your network status information to help solve the issue.': 'Vui lòng cho phép chúng tôi truy cập thông tin trạng thái mạng của bạn để hỗ trợ giải quyết vấn đề.',
  'Network testing is in progress. It may take 10–30 seconds. Please wait.': 'Đang kiểm tra mạng. Quá trình có thể mất 10–30 giây. Vui lòng chờ.',
  'Done! Thank you!': 'Xong rồi! Cảm ơn bạn!',
  OK: 'OK'
}

// 语言对象
const LANGUAGE: any = {
  'zh-CN': CHINESE, // 中文
  'zh-TW': ChineseTrad, // 繁体
  'zh-Hant': ChineseTrad, // 繁体
  'en-US': ENGLISH, // 英语
  'es-ES': SPANISH, // 西班牙语
  'de-DE': GERMAN, // 德语
  'ru-RU': RUSSIAN, // 俄罗斯语
  'fr-FR': FRENCH, // 法语
  'pt-PT': PORTUGUESE, // 葡萄牙语
  'ko-KR': KOREAN, // 韩语
  'it-IT': ITALIAN, // 意大利语
  'ja-JP': JAPANESE, // 日语
  'pl-PL': POLISH, // 波兰语
  'tr-TR': Turkish, // 土耳其语
  'nl-NL': Dutch, // 荷兰语
  'sv-SE': Swedish, // 瑞典语
  'da-DK': Danish, // 丹麦语
  'nb-NO': Norwegian, //  挪威语
  'fi-FI': Finnish, //  芬兰语
  'en-ID': Indonesian, // 印尼语
  'th-TH': Thai, // 泰语
  'ar-SA': Arabic, // 阿拉伯语
  'ro-RO': Romanian, // 罗马尼亚语
  'cs-CZ': Czech, // 捷克语
  'bg-BG': Bulgarian, // 保加利亚语
  'vi-VN': Vietnamese, // 越南语
}

/**
 * 走短键解析路径（LanguageShortKeyMaps：en → en-US）的 appid 白名单。
 * 这些站入口透传的是短语言键（en / fr），非完整 locale。
 * 马甲站主体 appid 由 isVestAppid 另行判定，二者共同构成 usesShortLocaleKey。
 */
export const SHORT_KEY_APPIDS = [
  'cm1006',
  'cm1007',
  'cm1003',
  'cm1009',
  'cm3002',
  'cm1012',
  'cm1015',
  'cm1013',
  'cm1018',
  'cm1017'
]

// 目前针对 Kiss、Reelshort、Magic 项目
export const LanguageShortKeyMaps = {
  en: 'en-US', //	English     英语
  es: 'es-ES', //	Spanish     西班牙语
  de: 'de-DE', //	German      德语
  ru: 'ru-RU', //	Russian     俄语
  fr: 'fr-FR', //	French      法语
  pt: 'pt-PT', //	Portuguese  葡萄牙语
  ko: 'ko-KR', //	Korean      韩语
  zh: 'zh-CN', //	Chinese     中文
  it: 'it-IT', // Italian     意大利语
  ja: 'ja-JP', // Japanese    日语
  pl: 'pl-PL', // Polish      波兰语
  tr: 'tr-TR', // Turkish     土耳其语
  nl: 'nl-NL', // Dutch       荷兰语
  sv: 'sv-SE', // Swedish     瑞典语
  da: 'da-DK', //	Danish      丹麦语
  nb: 'nb-NO', //	Norwegian   挪威语
  fi: 'fi-FI', //	Finnish     芬兰语
  in: 'en-ID', //	Indonesian  印尼语
  th: 'th-TH', //	Thai        泰语
  tw: 'zh-TW', // Chinese     繁体
  ar: 'ar-SA', // Arabic      阿拉伯语
  ro: 'ro-RO', // Romanian    罗马尼亚语
  cs: 'cs-CZ', // Czech       捷克语
  bg: 'bg-BG', // Bulgarian   保加利亚语
  vi: 'vi-VN', // Vietnamese  越南语
}

// Language Object -> Array -> Excel(https://uutool.cn/json2excel/)
// console.log(
//   Object.entries(LANGUAGE['en-US']).map(([id]) => {
//     return Object.fromEntries(
//       Object.keys(LANGUAGE).map((key) => [key, LANGUAGE[key][id]])
//     )
//   })
// )

export default LANGUAGE
